import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Accordion, Alert, Badge, Button, ButtonGroup, Card, CloseButton, Col, Container, FloatingLabel, Form, Image, InputGroup, Modal, ModalBody, ProgressBar, Row, Spinner, Tab, Table, Tabs, Toast, ToggleButton } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import { LinkContainer } from 'react-router-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { LoginInfo } from '../../App';
import ImageFile from '../../domain/ImageFile';
import * as ImageUtil from '../../service/ImageUtil';
import ApiFetch from '../ApiFetch';
import CampaignMessage from '../CampaignMessage';
import Dialog from '../Dialog';
import Footer from '../Footer';
import Header from '../Header';
import Category from '../Category';
import EXIF from 'exif-js';
import extractChunks from 'png-chunks-extract/index'
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import  {  Typeahead  }  from  'react-bootstrap-typeahead' ;
import  'react-bootstrap-typeahead/css/Typeahead.css' ;
import Cropper from 'react-easy-crop'
import {getStyleList,setStyle,deleteStyleList} from '../../service/AIGenerateService';
import Questionnaire from '../Questionnaire';
import RegistOrLogin from '../RegistOrLogin';
import AITalk from '../AITalk';
import { Bar } from 'react-chartjs-2';
import { login } from '../../service/LoginService';
import ExifReader from 'exifreader';
import TagSelector from '../TagSelector';
import Thumb from '../common/Thumb';
import DynamicDialog from '../DynamicDialog';
import { arrayShuffle, planDialog } from '../../service/CommonUtil';
import UserMark from '../UserMark';
import MuiButton from '@mui/material/Button';
import { ImageList ,ImageListItem, Skeleton , Slider, IconButton, Box, Checkbox, FormControl, FormControlLabel,TextField, FormLabel, Radio, RadioGroup, TableBody, Menu, Popper } from '@mui/material';
import CommonDialog from '../common/CommonDialog';
import { DataGrid } from '@mui/x-data-grid';
import CropButton from '../common/CropButton';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Tooltip from '@mui/material/Tooltip';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DeleteIcon from '@mui/icons-material/Delete';
import Popover from '@mui/material/Popover';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import Chip from '@mui/material/Chip';
import MuiToggleButton from '@mui/material/ToggleButton';
import MuiToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import Inpaint from '../common/Inpaint';
import PostLimit from './PostLimit';
import Fade from '@mui/material/Fade';
import Constants from '../common/Constants';
import DiamondIcon from '@mui/icons-material/Diamond';
import PaymentMethodSelector from './PaymentMethodSelector';

const UploadCharacter = (props) => {
    function getAIGeneraleImageList(userId,page){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/generated/"+userId+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getAIGeneraleImageFile(procId){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/getImage/"+procId+"/0").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function deleteAIGeneraleImageFile(procIdList){
        return new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/generatedHistory",{procIdList:procIdList}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function createZipFile(procIdList){
        return new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/dl",{procIdList:procIdList}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function existZipFile(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/existZip").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function getStatusCount(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/statusCount").then((r)=>{
            return r.json()
        })
    }
    function getStatus(procId){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/status/"+procId).then((r)=>{
            return r.json()
        })
    }
    function getPoint(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/point").then((r)=>{
            return r.json()
        })
    }
	async function getCoinInfo(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/coin/coinInfo").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function txt2img(booking,random,count,style,isFullMode,isFastMode,isScaleUpx2,enterJpPrompt,jpPrompt,prompt,negativePrompt,styleP,styleNP,sampler,upscaler,steps,scale,denoisingStrength,seed,width,height,hires){
        if(false === booking) setAiProccessing(true)
        if(enterJpPrompt){
            setJpPromptTranslating(true)
            document.getElementById("sd-prompt").value = ""
        }
        new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/txt2img",
            {mode:"txt2img",paymentMethod:paymentMethod,booking:booking ? 1 : 0,random:random ? 1 : 0,count:count,style:style,isFullMode:isFullMode,isFastMode:isFastMode,isScaleUpx2:isScaleUpx2,enterJpPrompt:enterJpPrompt,jpPrompt:jpPrompt,prompt:prompt,negativePrompt:negativePrompt,styleP:styleP,styleNP:styleNP,sampler:sampler,upscaler:upscaler,steps:steps,scale:scale,denoisingStrength:denoisingStrength,seed:seed,width:width,height:height,hires:hires}).then((r)=>{
            return r.json().then((json)=>{
                if(json.result){
                    if(booking){
                        dialog(t("common.info"),"予約しました。")
                    }
                    if(json.data.translatedPrompt){
                        document.getElementById("sd-prompt").value = json.data.translatedPrompt
                    }
                    setPoint(json.data.afterPoint)
                    setCoin(json.data.afterCoin)
                } else {
                    let error = json.errors.join("\r\n")
                    if(error.indexOf("利用規約への同意が必要です。") !== -1){
                        getTerms().then(r => {
                            if(r.result){
                                setAIGenTerms(r.text)
                            }
                        })
                    } else if(json.errors.join("\r\n").indexOf("継続するにはログインが必要です。") !== -1){
                        dialog("",<RegistOrLogin dialog={dialog} />)
                        return
                    } else if(error.indexOf("ポイントが不足しています。") !== -1){
                        dialog("エラー",
                        <Container>
                            ポイントが不足しています。<br /><br />

                            ポイント回復方法
                            <ul>
                                <li><Link to={"/legal"}>プレミアムプラン</Link>でポイント消費することなく画像生成できます(条件あり)。</li>
                                <li>翌日まで待てばポイント回復。<br />
                                    活動実績により変動。</li>
                                <li>作品の投稿やいいね、コメントを投稿することでポイント回復。</li>
                                <li>今日のお題に参加すると投稿時にもらえるポイントが2倍。</li>
                            </ul>
                        </Container>)
                    } else {
                        dialog("エラー",json.errors.join("\r\n"))
                    }
                    if(false === booking) setAiProccessing(false)
                }
                if(enterJpPrompt){
                    setJpPromptTranslating(false)
                }
                return json.result
            })
        })
    }
    function img2img(booking,random,count,style,isFullMode,isFastMode,isScaleUpx2,img,mask,enterJpPrompt,jpPrompt,prompt,negativePrompt,styleP,styleNP,sampler,upscaler,steps,scale,denoisingStrength,seed,width,height){
        if(false === booking) setAiProccessing(true)
        if(enterJpPrompt){
            setJpPromptTranslating(true)
            document.getElementById("sd-prompt").value = ""
        }
        new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/img2img",
            {mode:"img2img",paymentMethod:paymentMethod,random:random ? 1 : 0,count:count,style:style,isFullMode:isFullMode,isFastMode:isFastMode,isScaleUpx2:isScaleUpx2,img:img,mask:mask,enterJpPrompt:enterJpPrompt,jpPrompt:jpPrompt,prompt:prompt,negativePrompt:negativePrompt,styleP:styleP,styleNP:styleNP,sampler:sampler,upscaler:upscaler,steps:steps,scale:scale,denoisingStrength:denoisingStrength,seed:seed,width:width,height:height}).then((r)=>{
            return r.json().then((json)=>{
                if(json.result){
                    if(booking){
                        dialog(t("common.info"),"予約しました。")
                    }
                    if(json.data.translatedPrompt){
                        document.getElementById("sd-prompt").value = json.data.translatedPrompt
                    }
                    setPoint(json.data.afterPoint)
                    setCoin(json.data.afterCoin)
                } else {
                    let error = json.errors.join("\r\n")
                    if(error.indexOf("利用規約への同意が必要です。") !== -1){
                        getTerms().then(r => {
                            if(r.result){
                                setAIGenTerms(r.text)
                            }
                        })
                    } else if(json.errors.join("\r\n").indexOf("継続するにはログインが必要です。") !== -1){
                        dialog("",<RegistOrLogin dialog={dialog} />)
                        return
                    } else if(error.indexOf("ポイントが不足しています。") !== -1){
                        dialog("エラー",
                        <Container>
                            ポイントが不足しています。<br /><br />

                            ポイント回復方法
                            <ul>
                                <li><Link to={"/legal"}>プレミアムプラン</Link>でポイント消費することなく画像生成できます(条件あり)。</li>
                                <li>翌日まで待てばポイント回復。<br />
                                    活動実績により変動。</li>
                                <li>作品の投稿やいいね、コメントを投稿することでポイント回復。</li>
                                <li>今日のお題に参加すると投稿時にもらえるポイントが2倍。</li>
                            </ul>
                        </Container>)
                    } else {
                        dialog("エラー",json.errors.join("\r\n"))
                    }
                    if(false === booking) setAiProccessing(false)
                }
                if(enterJpPrompt){
                    setJpPromptTranslating(false)
                }
                return json.result
            })
        })
    }
    function txt2imgControlnet(booking,random,count,style,isFullMode,isFastMode,isScaleUpx2,img,mask,enterJpPrompt,jpPrompt,prompt,negativePrompt,styleP,styleNP,sampler,upscaler,steps,scale,denoisingStrength,seed,width,height){
        if(false === booking) setAiProccessing(true)
        if(enterJpPrompt){
            setJpPromptTranslating(true)
            document.getElementById("sd-prompt").value = ""
        }
        new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/txt2img",
            {mode:"txt2img",paymentMethod:paymentMethod,random:random ? 1 : 0,count:count,style:style,controlnet:useControlnet ? 1 : 0,controlnetModule:"lineart_anime_denoise",controlnetModel:"Katarag_lineartXL-fp16 [ac23a680]",isFullMode:isFullMode,isFastMode:isFastMode,isScaleUpx2:isScaleUpx2,img:img,mask:mask,enterJpPrompt:enterJpPrompt,jpPrompt:jpPrompt,prompt:prompt,negativePrompt:negativePrompt,styleP:styleP,styleNP:styleNP,sampler:sampler,upscaler:upscaler,steps:steps,scale:scale,denoisingStrength:denoisingStrength,seed:seed,width:width,height:height}).then((r)=>{
            return r.json().then((json)=>{
                if(json.result){
                    if(booking){
                        dialog(t("common.info"),"予約しました。")
                    }
                    if(json.data.translatedPrompt){
                        document.getElementById("sd-prompt").value = json.data.translatedPrompt
                    }
                    setPoint(json.data.afterPoint)
                    setCoin(json.data.afterCoin)
                } else {
                    let error = json.errors.join("\r\n")
                    if(error.indexOf("利用規約への同意が必要です。") !== -1){
                        getTerms().then(r => {
                            if(r.result){
                                setAIGenTerms(r.text)
                            }
                        })
                    } else if(json.errors.join("\r\n").indexOf("継続するにはログインが必要です。") !== -1){
                        dialog("",<RegistOrLogin dialog={dialog} />)
                        return
                    } else if(error.indexOf("ポイントが不足しています。") !== -1){
                        dialog("エラー",
                        <Container>
                            ポイントが不足しています。<br /><br />

                            ポイント回復方法
                            <ul>
                                <li><Link to={"/legal"}>プレミアムプラン</Link>でポイント消費することなく画像生成できます(条件あり)。</li>
                                <li>翌日まで待てばポイント回復。<br />
                                    活動実績により変動。</li>
                                <li>作品の投稿やいいね、コメントを投稿することでポイント回復。</li>
                                <li>今日のお題に参加すると投稿時にもらえるポイントが2倍。</li>
                            </ul>
                        </Container>)
                    } else {
                        dialog("エラー",json.errors.join("\r\n"))
                    }
                    if(false === booking) setAiProccessing(false)
                }
                if(enterJpPrompt){
                    setJpPromptTranslating(false)
                }
                return json.result
            })
        })
    }
    function upScale(img,style,scale){
        setAiProccessing(true)
        new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/extraBatchImages",
            {img:[img],style:style,scale:scale}).then((r)=>{
            return r.json().then((json)=>{
                if(json.result){
                    setPoint(json.data.afterPoint)
                    setCoin(json.data.afterCoin)
                } else {
                    let error = json.errors.join("\r\n")
                    if(error.indexOf("利用規約への同意が必要です。") !== -1){
                        getTerms().then(r => {
                            if(r.result){
                                setAIGenTerms(r.text)
                            }
                        })
                    } else if(json.errors.join("\r\n").indexOf("継続するにはログインが必要です。") !== -1){
                        dialog("",<RegistOrLogin dialog={dialog} />)
                        return
                    } else if(error.indexOf("ポイントが不足しています。") !== -1){
                        dialog("エラー",
                        <Container>
                            ポイントが不足しています。<br /><br />

                            ポイント回復方法
                            <ul>
                                <li><Link to={"/legal"}>プレミアムプラン</Link>でポイント消費することなく画像生成できます(条件あり)。</li>
                                <li>翌日まで待てばポイント回復。<br />
                                    活動実績により変動。</li>
                                <li>作品の投稿やいいね、コメントを投稿することでポイント回復。</li>
                                <li>今日のお題に参加すると投稿時にもらえるポイントが2倍。</li>
                            </ul>
                        </Container>)
                    } else {
                        dialog("エラー",json.errors.join("\r\n"))
                    }
                    setAiProccessing(false)
                }
                return json.result
            })
        })
    }
    function getOdai(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/odai/latest").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function calcPoint(postCount){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/point/calc/"+postCount).then((r)=>{
            return r.json()
        })
    }
    function getSeriesList(userId){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/series/list/"+userId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function getUsersByDay(){
        return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/users").then((r)=>{
            return r.json()
        })
    }
    function tagSearch(word){
        return new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/tag/search/",{word:word}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getEvent(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/event/hold/").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getTagLatest(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/tag/latest/image").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getHowToText(tag){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/text/tag",{tag:tag,page:1}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getBookingTimeList(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/bookingTimeList").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getPeriod(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/freeCampaign/period/image_generate").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getPromptByDetailId(detailId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/promptDetail/"+detailId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getPromptByShareId(shareId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/promptShare/"+shareId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function createShareId(procId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/createShare/"+procId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function terms(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/terms/").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function getTerms(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/messages/terms").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function termsAgree(){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/terms").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getPlanList(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/plan/peoples/")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function getAdList(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/ad/list/generating_image/107305bd-dd69-47a7-bfb3-a099862463f0").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function getModelList(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/modelList").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function getFavoriteModelList(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/favoriteModelList").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function favorite(id,flg){
        if(flg){
            new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/favorite/image_ai_model/"+id,{}).then((res) => {
                res.json().then((json)=>{
                    if(json.result){
                        getModelList().then(r => {
                            if(r.result){
                                setModelList(r.data)
                            }
                        })
                    } else {
                    }
                })  
            })
        } else {
            new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/favorite/image_ai_model/"+id,{}).then((res) => {
                res.json().then((json)=>{
                    if(json.result){
                        getModelList().then(r => {
                            if(r.result){
                                setModelList(r.data)
                            }
                        })
                    } else {
                    }
                })  
            })
        }
    }
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲーション
    const navigate = useNavigate()
    const param = useParams()

    // 無料期間情報
    const [freePeriodInfo,setFreePeriodInfo] = useState([])
    const [free,setFree] = useState(false)

    // イベント一覧
    const [eventList,setEventList] = useState([])
    const [eventTag,setEventTag] = useState("")

    // ノウハウ文書
    const [howTo,setHowTo] = useState([])

    // プラン一覧
    const [planList,setPlanList] = useState([])
    // 広告一覧
    const [adInfo,setAdInfo] = useState([])
    const adList = [
        /*  {"isAd":true,"title":"AIイラスト入門用ノートPC","text":"[PR]Amazonブラックフライデー先行セール中！","element":<>
        <a href="https://www.amazon.co.jp/ASUS-%E3%82%B2%E3%83%BC%E3%83%9F%E3%83%B3%E3%82%B0%E3%83%8E%E3%83%BC%E3%83%88PC-%E3%83%AA%E3%83%95%E3%83%AC%E3%83%83%E3%82%B7%E3%83%A5%E3%83%AC%E3%83%BC%E3%83%88144Hz-RGB%E3%82%A4%E3%83%AB%E3%83%9F%E3%83%8D%E3%83%BC%E3%83%88%E3%82%AD%E3%83%BC%E3%83%9C%E3%83%BC%E3%83%89-FA507RM-R76R3060A/dp/B0CHVSCDQ4?__mk_ja_JP=%E3%82%AB%E3%82%BF%E3%82%AB%E3%83%8A&keywords=rtx+3060&qid=1700666016&sr=8-3-spons&sp_csd=d2lkZ2V0TmFtZT1zcF9tdGY&psc=1&linkCode=li2&tag=ourt-ai-22&linkId=fe5c358f8ccb351d2f9a0779a8e608d0&language=ja_JP&ref_=as_li_ss_il" target="_blank">
            <img border="0" src="//ws-fe.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B0CHVSCDQ4&Format=_SL160_&ID=AsinImage&MarketPlace=JP&ServiceVersion=20070822&WS=1&tag=ourt-ai-22&language=ja_JP" />
        </a>
            <img src="https://ir-jp.amazon-adsystem.com/e/ir?t=ourt-ai-22&language=ja_JP&l=li2&o=9&a=B0CHVSCDQ4" width="1" height="1" border="0" alt="" style={{border:"none !important", margin:"0px !important"}} /></>},
        */
        {"isAd":true,"title":"ベーシックプランで広告非表示","text":"月額500円で広告非表示のプランです。","element":<Button variant="primary" onClick={() => planDialog(dialog)}>プラン詳細</Button>},
        {"isAd":true,"title":"プレミアムプランで高画質で回数無制限","text":"広告非表示。ポイントの消費を気にせず生成しよう。","element":<Button variant="primary" onClick={() => planDialog(dialog)}>プラン詳細</Button>},
        {"isAd":true,"title":"有料プランでは生成が優先されます","text":"専用環境で待機時間の短縮を。対象プラン：スタンダード、プレミアム、プレミアムプラス","element":<Button variant="primary" onClick={() => planDialog(dialog)}>プラン詳細</Button>},
        {"isAd":true,"title":"有料プラン専用マーク","text":"各プランに加入すると、名前の隣にプランを表すマークが付与されます。","element":<>
            <UserMark plan="basic" dialog={() => false} />&nbsp;&nbsp;&nbsp;&nbsp;ベーシック<br />
            <UserMark plan="certification" dialog={() => false} />&nbsp;&nbsp;&nbsp;&nbsp;スタンダード<br />
            <UserMark plan="unlimited" dialog={() => false} />&nbsp;プレミアム<br />
            <UserMark plan="plus" dialog={() => false} />&nbsp;プレミアムプラス <b>(最初の1か月20% OFF)</b><br /><br />
        <Button variant="primary" onClick={() => planDialog(dialog)}>プラン詳細</Button></>},
    ]
    useEffect(() => {
        getEvent().then(r => {
            if(r.result){
                setEventList(r.data)
            }
        })
        getHowToText("ノウハウ").then(r => {
            if(r.result){
                setHowTo(r.data)
            }
        })

        getPeriod().then(r => {
            if(r.result){
                setFreePeriodInfo(r.data)
                setFree(r.data.enabled === 1)
            }
        })
        // 参考にする詳細IDがあれば取得
        const match = window.location.href.match(/.+?[^s]id=([0-9\-a-z]{36})/)
        if(match !== null && match.length === 2){
            getPromptByDetailId(match[1]).then(r => {
                setSrcMode(true)
                if(r.result){
                    //setSdResolution("512x768")
                    setSdStyle("ourt_AI_Diffusion_XL_Anime_V1")
                    document.querySelector("#sd-seed").value = -1
                    document.querySelector("#sd-prompt").value = r.data.prompt
                    document.querySelector("#sd-negative-prompt").value = r.data.negative_prompt
                    setQualityTags(false)
                } else {
                    dialog(t("common.error"),r.errors)
                }
            })
        }
        const matchP = window.location.href.match(/.+?sid=([0-9\-a-z]{36})/)
        if(matchP !== null && matchP.length === 2){
            getPromptByShareId(matchP[1]).then(r => {
                if(r.result){
                    setSrcMode(true)
                    const d = r.data
                    setSdScale(d.cfg_scale)
                    if(d.denoising_strength === ""){
                        setSdDenoisingStrength("0.5")   
                    } else {
                        setSdDenoisingStrength(d.denoising_strength)
                    }
                    if(d.enable_hr === 1){
                        const width = parseInt(d.width) * 2
                        const height = parseInt(d.height) * 2
                        setSdResolution(width+"x"+height+"h")
                    } else {
                        setSdResolution(d.width+"x"+d.height)
                    }
                    setSdStyle(d.sd_model_checkpoint)
                    //setSdSeed(d.real_seed)
                    setSdSteps(d.steps)
                    setSdSampler(d.sampler)
                    setSdStyle(d.style)
                    //document.querySelector("#sd-seed").value = d.real_seed
                    document.querySelector("#sd-prompt").value = d.prompt
                    document.querySelector("#sd-negative-prompt").value = d.negative_prompt
                    setQualityTags(false)
                } else {
                    dialog(t("common.error"),r.errors)
                }
            })
        }
        getAdList().then(r => {
            if(r.result){
                setAdInfo(r.data)
            }
        })
        getModelList().then(r => {
            if(r.result){
                setModelList(r.data)
            }
        })
    },[])

    useEffect(() => {
        if(loginInfo.result){
            getPlanList().then(r => {
                if(r.result){
                    setRows(r.data.map(d => {
                        d.id = d.plan_id
                        d.amount = "￥"+d.amount.toLocaleString()
                        return d
                    }))
                } else {
                    setRows([].concat())
                }
            })
        }
    },[loginInfo])

    const [aiGenTerms,setAIGenTerms] = useState("")
    const [srcMode,setSrcMode] = useState(false)

    // 最新タグ
    const [tagLatest,setTagLatest] = useState([])

    // よく使う予約時刻一覧
    const [bookingTimeList,setBookingTimeList] = useState([])
    const [showBookingDatetime,setShowBookingDatetime] = useState(false)

    // お題
    const [odai,setOdai] = useState([])
    const [useOdai,setUseOdai] = useState(false)

    // フラグ
    const [batchMode,setBatchMode] = useState(false)
    const [useFilename,setUseFilename] = useState(false)
    const [notReadPromptInfo,setNotReadPromptInfo] = useState(false)
    const [promptInfoPublication,setPromptInfoPublication] = useState(true)

    // アップロード処理
    const [batchUploading,setBatchUploading] = useState(false)
    const [batchProgressNow,setBatchProgressNow] = useState(0)
    const [batchProgressLabel,setBatchProgressLabel] = useState(0)
    const [uploading,setUploading] = useState(false)
    const [progressNow,setProgressNow] = useState(0)
    const [progressLabel,setProgressLabel] = useState(0)
    const maxFileSize = 31457280000
    // 104857600 100MB
    // 262144000 200MB
    // 31457280000 30GB
    localStorage.getItem("sd-style")
    localStorage.getItem("sd-resolution")
    localStorage.getItem("sd-sampler")
    localStorage.getItem("sd-steps")
    localStorage.getItem("sd-generate-mode")
    localStorage.getItem("sd-scale")
    localStorage.getItem("sd-seed")
    localStorage.getItem("sd-quality-tags")
    // AIでの生成関連
    const [useAiGenerate,setUseAiGenerate] = useState(param.generate === "generate" || false) // 生成を使用
    const [jpPromptTranslating,setJpPromptTranslating] = useState(false) // 翻訳中
    const [aiProccessing,setAiProccessing] = useState(false) // 生成処理中
    const [qualityTags,setQualityTags] = useState(localStorage.getItem("sd-quality-tags") === "true")
    const [point,setPoint] = useState(0)
    const [pointCost,setPointCost] = useState(0)
    const [coinCost,setCoinCost] = useState(0)
    const [upscalePointCost,setUpscalePointCost] = useState(0)
    const [upscaleCoinCost,setUpscaleCoinCost] = useState(0)
    const [calcPointInfo,setCalcPointInfo] = useState([])
    const [sdStyle,setSdStyle] = useState(localStorage.getItem("sd-style") || "ourt_AI_Diffusion_XL_Anime_V1")
    const [modelImage,setModelImage] = useState("")
    const [modelName,setModelName] = useState("")
    const [modelDescription,setModelDescription] = useState("")
    const [modelType,setModelType] = useState("")
    const [modelIdentifiedName,setModelIdentifiedName] = useState("")
    const [modelOptions,setModelOptions] = useState([])
    const [bgName,setBgName] = useState("")
    const [sdResolution,setSdResolution] = useState(localStorage.getItem("sd-resolution") || "768x1152")
    const [sdWidth,setSdWidth] = useState(768)
    const [sdHeight,setSdHeight] = useState(1152)
    const [fastModeVer,setFastModeVer] = useState("0")
    const [isFastMode,setIsFastMode] = useState(false)
    const [isFullMode,setIsFullMode] = useState(false)
    const [useControlnet,setUseControlnet] = useState(false)
    const [modelFullModeEnable,setModelFullModeEnable] = useState(false)
    const [isScaleUpx2,setIsScaleUpx2] = useState(false)
    const [sdSampler,setSdSampler] = useState("DPM++ 2M SDE Karras")
    const [sdUpscaler,setSdUpscaler] = useState("R-ESRGAN 4x+ Anime6B")
    const [sdSteps,setSdSteps] = useState(localStorage.getItem("sd-steps") || 28)
    const [sdScale,setSdScale] = useState(localStorage.getItem("sd-scale") || 12)
    const [sdDenoisingStrength,setSdDenoisingStrength] = useState(0.5)
    const [sdSeed,setSdSeed] = useState(localStorage.getItem("sd-seed") || -1)
    const [sdImagesCount,setSdImagesCount] = useState("1")
    const [aiGenerateImageList,setAIGenerateImageList] = useState([]) // AI生成履歴
    const [generateImageListCols,setGenerateImageListCols] = useState(localStorage.getItem("generateImageListCols") || 3) // AI生成履歴の表示列数
    const [displayAIGeneratedPanel,setDisplayAIGeneratedPanel] = useState(false) // AI生成履歴パネルの表示
    const [aiGenerateImagePage,setAIGenerateImagePage] = useState(-1) // AI生成履歴パネルのページ
    const [aiGenerateReset,setAIGenerateReset] = useState(false) // AI生成履歴を再取得するためのフラグ
    const [generateMode,setGenerateMode] = useState("txt2img") // 生成モード
    const [showSettings,setShowSettings] = useState(false) // settings表示
    const [generateTabKey,setGenerateTabKey] = useState("txt2img") // 生成タブキー表示
    const [img2ImgFile,setImg2ImgFile] = useState() // img2imgのbase64
    const [inpaintFile,setInpaintFile] = useState() // inpaintする元画像のbase64
    const [inpaintMask,setInpaintMask] = useState() // inpaintで使用するmask画像
    const [selectedImageWidth,setSelectedImageWidth] = useState(0) // img2imgのbase64のwidth
    const [selectedImageHeight,setSelectedImageHeight] = useState(0) // img2imgのbase64のheight
    const [dlImages,setDLImages] = useState() // DL中
    const [modelList,setModelList] = useState([]) // モデル一覧
    const [modelSearchWord,setModelSearchWord] = useState("") // モデル検索
    const [tabKey,setTabKey] = useState("osusume") // 生成モデル一覧タブ
    const [generatedImageListHeight,setGeneratedImageListHeight] = useState("100px")
    const [scaleBy,setScaleBy] = useState(4) // アップスケール倍率

    // コイン関連
    const [coinInfo,setCoinInfo] = useState([])
    const [coin,setCoin] = useState(0)
    useEffect(() => {
        if(useAiGenerate){
            getCoinInfo().then(r => {
                if(r.result){
                    setCoinInfo(r.data)
                    setCoin(r.data.coin)
                    /*setChargeList(r.data.chargeList)
                    setUsageList(r.data.usageList)*/
                }
            })
        }
    },[useAiGenerate])

    useEffect(() => {
        localStorage.removeItem("generateImageListCols")
        localStorage.setItem("generateImageListCols",generateImageListCols)
    },[generateImageListCols])

    useEffect(() => {
        setUseAiGenerate(param.generate === "generate")
        if(param.generate === "generate"){
            aiGenInitHandler(true)
        }
    },[param.generate])

    let procId = ""
    useEffect(() => {
        if(aiGenerateImagePage > 0 && loginInfo.result){
            //calcCost()
            getAIGeneraleImageList(loginInfo.userId,aiGenerateImagePage).then(r => {
                if(r.result){
                    if(r.data.length > 0){
                        if(aiGenerateImagePage === 1){
                            setAIGenerateImageList([].concat(r.data))
                        } else {
                            setAIGenerateImageList(aiGenerateImageList.concat(r.data))
                        }
                    } else {
                        if(aiGenerateImagePage === 1){
                            setAIGenerateImageList([])
                            //dialog("","履歴がありません。AI生成機能を利用してみませんか？")
                        }
                    }
                } else {
                    setAIGenerateImageList([])
                    dialog("確認",r.errors)
                }
                let elm = document.getElementById("generated-image-list")
                if(elm !== null && window){
                    let newHeight = window.innerHeight - elm.offsetTop
                    setGeneratedImageListHeight(newHeight)
                }
            })
        }
    },[loginInfo,aiGenerateImagePage,aiGenerateReset])

    // 画像遅延ロード
    useEffect(() => {
        document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    },[aiGenerateImageList])

    // 投稿遅延ロード
    const options = {
        root: null,
        rootMargin: "500px",
        threshold: 0.05
    }
    const observer = new IntersectionObserver((entries,observer)=>{
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0){
                const imgEl = entry.target;
                //imgEl.src = imgEl.dataset.src;          
                observer.unobserve(entry.target);
                // ロードした部分まで進んだら追加読み込み
                if(imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (aiGenerateImagePage * 200 - 1) ){
                    setAIGenerateImagePage(aiGenerateImagePage+1)
                    console.log(aiGenerateImagePage)
                }
              }
        })
    }, options);

    // 編集情報
    const [editImageNo,setEditImageNo] = useState(0)
    const [editImageTargetNo,setEditImageTargetNo] = useState(-1)
    const [editLabel,setEditLabel] = useState("モザイク描画")
    const [previewSource,setPreviewSource] = useState("")
    const [previewFlg,setPreviewFlg] = useState(false)
    const ref = React.createRef()
    const styleRef = React.createRef()
    const [styleOptions,setStyleOptions] = useState([])
    const [styleSelected,setStyleSelected] = useState([])
    const [generateMethodSelected,setGenearteMethodSelected] = useState([])
    const [optionSelected,setOptionSelected] = useState([])
    const [enterJpPrompt,setEnterJpPrompt] = useState(false)
    const [jpCost,setJpCost] = useState(0)
    const [aiTalkShow,setAiTalkShow] = useState(false)
    const [tagSelectorShow,setTagSelectorShow] = useState(false)
    const [bookingDate,setBookingDate] = useState("")
    const [bookingTime,setBookingTime] = useState("")
    const [tagOptions, setTagOptions] = useState([])
    const [tag, setTag] = useState([])

    // 投稿完了後
    const [postedGroupId,setPostedGroupId] = useState("")
    const [url,setURL] = useState("")
    const [imgUrl,setImgURL] = useState("")
    let timer
    let uploadProgressNo = 0
    let oldUploadProgressNo = 1

    function uploadSelect(files){
        // アップロード開始
        setUploading(true)
        // 入力フォーム無効化
        setDisabled()
        let batch = document.getElementById("batch").checked
        if(batch){
            setBatchUploading(true)
            timer = setInterval(() => {
                if(!uploading){
                    if(uploadProgressNo < files.length){
                        if(uploadProgressNo !== oldUploadProgressNo){
                            upload([files[uploadProgressNo]])
                            let per = Math.floor((uploadProgressNo + 1) / files.length * 100)
                            let label = ""
                            if(per === 100){
                                label = "登録中"
                            } else {
                                label = per + "%"
                            }
                            setBatchProgressNow(per)
                            setBatchProgressLabel(label)
                        }
                        oldUploadProgressNo = uploadProgressNo
                    }
                }
            },500)
        } else {
            upload(files)
        }
    }

    /**
     * 入力フォームを無効化する
     */
    function setDisabled(){
        let elements = ["batch","title","description","original","limited-publication",
            "ai-model","prompt","negative-prompt","delete-password"
            ,"noise","steps","scale","seed","sampler","strength","mask-blur",
            "clip-skip","controlnet-enabled","controlnet-module","controlnet-model","controlnet-weight",
            "ensd","hires-upscale","hires-upscaler","raw-info"
        ]
        elements.forEach(id => {
            if(loginInfo.result && id === "delete-password") return
            let elm = document.getElementById(id)
            if(elm !== null)
            elm.setAttribute("disabled",true)
        })
    }

    /**
     * 入力フォームの無効化を解除する
     */
    function unsetDisabled(){
        let elements = ["batch","title","description","original","limited-publication",
            "ai-model","prompt","negative-prompt","delete-password"
            ,"noise","steps","scale","seed","sampler","strength","mask-blur",
            "clip-skip","controlnet-enabled","controlnet-module","controlnet-model","controlnet-weight",
            "ensd","hires-upscale","hires-upscaler","raw-info"
        ]
        elements.forEach(id => {
            if(loginInfo.result && id === "delete-password") return
            let elm = document.getElementById(id)
            if(elm !== null)
            elm.removeAttribute("disabled")
            
        })
    }

    /**
     * 入力フォームの内容をリセットする
     */
    function deleteFormValue(){
        let elements = ["batch","title","description"]
        elements.forEach(id => {
            let elm = document.getElementById(id)
            elm.value = ""
        })
        document.getElementById("batch").checked = false
        //document.getElementById("original").checked = false
        //document.getElementById("limited-publication").checked = false

        document.getElementById("ai-model").value = "no-select"
        document.getElementById("prompt").value = ""
        document.getElementById("negative-prompt").value = ""
        document.getElementById("noise").value = ""
        document.getElementById("steps").value = ""
        document.getElementById("scale").value = ""
        document.getElementById("seed").value = ""
        document.getElementById("sampler").value = ""
        document.getElementById("strength").value = ""
        document.getElementById("mask-blur").value = ""
        document.getElementById("model-version").value = ""
        document.getElementById("clip-skip").value = ""
        document.getElementById("controlnet-enabled").value = ""
        document.getElementById("controlnet-module").value = ""
        document.getElementById("controlnet-model").value = ""
        document.getElementById("controlnet-weight").value = ""
        document.getElementById("ensd").value = ""
        document.getElementById("hires-upscale").value = ""
        document.getElementById("hires-upscaler").value = ""
        document.getElementById("raw-info").value = ""
        setVAE([])
        setGPU([])
        setVRAM([])

        if(loginInfo.length === 0){
            let deletePassword = document.getElementById("delete-password")
            deletePassword.value = ""
        }
        setFileList([])
    }

    /**
     * 現在の情報を削除する
     */
    function deleteSelectedFormValue(){
        document.getElementById("ai-model").value = "no-select"
        document.getElementById("prompt").value = ""
        document.getElementById("negative-prompt").value = ""
        document.getElementById("noise").value = ""
        document.getElementById("steps").value = ""
        document.getElementById("scale").value = ""
        document.getElementById("seed").value = ""
        document.getElementById("sampler").value = ""
        document.getElementById("strength").value = ""
        document.getElementById("mask-blur").value = ""
        document.getElementById("model-version").value = ""
        document.getElementById("clip-skip").value = ""
        document.getElementById("controlnet-enabled").value = ""
        document.getElementById("controlnet-module").value = ""
        document.getElementById("controlnet-model").value = ""
        document.getElementById("controlnet-weight").value = ""
        document.getElementById("ensd").value = ""
        document.getElementById("hires-upscale").value = ""
        document.getElementById("hires-upscaler").value = ""
        document.getElementById("raw-info").value = ""
        setVAE([])
        setGPU([])
        setVRAM([])

        if(fileList.length > 0){
            fileList.filter((d,i) => i === editImageNo).map(r => {
                r.prompt = ""
                r.software = "no-select"
                r.softwareLocked = "0"
                r.modelHash = ""
                r.rawInfo = ""
                r.useAIGeneration = false
                r.comment = {uc:"",noise:"",steps:"",scale:"",seed:"",sampler:"",strength:"",maskBlur:"",
                    clipSkip:"",controlNetEnabled:"",controlNetModule:"",controlNetModel:"",controlNetWeight:"",ensd:"",
                    hiresUpscale:"",hiresUpscaler:""
                }
                r.error = false
                return r
            })
        }
    }

    function upload(files){
        let fd = new FormData()
        let batch = document.getElementById("batch").checked
        let bookingDatetime = ""
        if(bookingDate.length > 0 && bookingTime.length > 0){
            bookingDatetime = bookingDate + " " + bookingTime
        } else {
            bookingDatetime = ""
        }

        // 一括投稿モードかつファイル名利用フラグが有効の場合、ファイル名から拡張子をとったものをタイトルに設定
        if(batch && useFilename){
            let title = files[0].file.name.replace(/\..[^.]+?$/,"").substring(0,100)
            if(title === ""){
                title = "無題"
            }
            fd.append("characterName",title)
        } else {
            fd.append("characterName",characterName)
        }
        fd.append("characterNameKana",characterNameKana)
        fd.append("characterSex",characterSex)
        if(birthdaySet === "1"){
            if(month === undefined) dialog("","誕生日(月)を入力してください。")
            if(day === undefined) dialog("","誕生日(日)を入力してください。")
            fd.append("characterBirthday",(month < 10 ? "0"+month : month) + "-" + (day < 10 ? "0"+day : day))
        } else {
            fd.append("characterBirthday","00-00")
        }
        fd.append("characterAge",characterAge)
        fd.append("styleOfPainting",styleOfPainting)
        fd.append("original",optionSelected.findIndex(v => v.value === "original") !== -1 ? "1" : "0")
        fd.append("bookingDatetime",bookingDatetime)
        fd.append("ageLimit",ageLimit)
        fd.append("sexualExpression",sexualExpression)
        fd.append("limitDiv",limitDiv)
        selectionPlans.forEach(d => {
            fd.append("selectionPlans[]",d)
        })
        fd.append("unitAmount",unitAmount)
        fd.append("loggedInUserOnly",optionSelected.findIndex(v => v.value === "loggedInUserOnly") !== -1 ? "1" : "0")
        fd.append("limitedPublication",optionSelected.findIndex(v => v.value === "limitedPublication") !== -1 ? "1" : "0")
        fd.append("displayNewList",optionSelected.findIndex(v => v.value === "newPostHidden") !== -1 || batch ? "1" : "0")
        fd.append("displayRanking",optionSelected.findIndex(v => v.value === "rankingHidden") !== -1 ? "1" : "0")
        fd.append("sensitive",optionSelected.findIndex(v => v.value === "sensitive") !== -1 ? "1" : "0")
        fd.append("editImageNo",editImageNo) // 標準サムネイル番号
        fd.append("seriesId",series.id !== undefined ? series.id : "") // シリーズID

        if(batch){
            if(uploadProgressNo === 0){
                fd.append("insideThumbnail",insideThumbnail !== undefined ? insideThumbnail : "")
                fd.append("outsideThumbnail",outsideThumbnail !== undefined ? outsideThumbnail : "")
                if(questionInfo !== undefined){
                    if(questionInfo.options.filter(v => v.length > 0).length > 0){
                        fd.append("questionDeadlineDatetime",questionInfo.deadlineDate + " " + questionInfo.deadlineTime)
                        questionInfo.options.filter(v => v.length > 0).forEach(d => {
                            fd.append("questionOptions[]",d)
                        })
                    }
                }
            }
        } else {
            fd.append("insideThumbnail",insideThumbnail !== undefined ? insideThumbnail : "")
            fd.append("outsideThumbnail",outsideThumbnail !== undefined ? outsideThumbnail : "")
            if(questionInfo !== undefined){
                if(questionInfo.options.filter(v => v.length > 0).length > 0){
                    fd.append("questionDeadlineDatetime",questionInfo.deadlineDate + " " + questionInfo.deadlineTime)
                    questionInfo.options.filter(v => v.length > 0).forEach(d => {
                        fd.append("questionOptions[]",d)
                    })
                }
            }
        }
        fd.append("request",document.getElementById("request").value)
        let description = document.getElementById("description").value

        let aiModel = document.getElementById("ai-model")
        if(aiModel.value !== "no-select"){
            if(description.indexOf(aiModel.value) === -1){
                description += "\n#" + aiModel.value.replace(/-/g,"_").replace(/\s/g,"_").replace(/\(|\)/g,"_").replace(/_+/g,"_").replace(/_$/g,"")
                if(description.indexOf("#AIイラスト") === -1){
                    // description += " #AIイラスト #AIart"
                }
            }
        }
        // イベントタグ
        if(eventTag.length > 0 && description.indexOf("#"+eventTag) === -1){
            description += "\n#" + eventTag
        }
        // タグ
        if(tag.length > 0){
            description += "\n" + tag.map(d => "#"+d).join(" ")
        }

        if(generateMethodSelected.findIndex(v => v.value === "t2i") !== -1) description += " #t2i"
        if(generateMethodSelected.findIndex(v => v.value === "i2i") !== -1) description += " #i2i"
        if(generateMethodSelected.findIndex(v => v.value === "inpaint") !== -1) description += " #inpaint"
        if(generateMethodSelected.findIndex(v => v.value === "outpaint") !== -1) description += " #outpaint"
        if(generateMethodSelected.findIndex(v => v.value === "ip2p") !== -1) description += " #ip2p"
        if(generateMethodSelected.findIndex(v => v.value === "ControlNet") !== -1) description += " #ControlNet"

        let promptFound = false
        for(let i = 0;i < files.length;i++){
            let useMosaic = files[i].useMosaic
            let imageDataOriginal = files[i].imageDataOriginal
            fd.append("useMosaic[]",useMosaic ? "1" : "0")
            fd.append("imageDataOriginal[]",useMosaic ? base64ToFile(imageDataOriginal.replace(/^.*,/, ''),files[i].file.name,"image/png") : "")
            // 使用モデルは必須
            let software = files[i].software ? files[i].software : ""
            fd.append("software[]",software.replace(/-/g,"_").replace(/\s/g,"_").replace(/\(|\)/g,"_").replace(/_+/g,"_").replace(/_$/g,""))

            if(promptInfoPublication){
                let modelHash = files[i].modelHash ? files[i].modelHash : ""
                let prompt = files[i].prompt ? files[i].prompt : ""
                let negativePrompt = files[i].comment !== undefined ? files[i].comment.uc : ""
                let noise = files[i].comment !== undefined ? files[i].comment.noise : ""
                let steps = files[i].comment !== undefined ? files[i].comment.steps : ""
                let scale = files[i].comment !== undefined ? files[i].comment.scale : ""
                let seed = files[i].comment !== undefined ? files[i].comment.seed : ""
                let sampler = files[i].comment !== undefined ? files[i].comment.sampler : ""
                let strength = files[i].comment !== undefined ? files[i].comment.strength : ""
                let maskBlur = files[i].comment !== undefined ? files[i].comment.maskBlur : ""
                let clipSkip = files[i].comment !== undefined ? files[i].comment.clipSkip : ""
                let controlNetEnabled = files[i].comment !== undefined ? files[i].comment.controlNetEnabled : ""
                let controlNetModule = files[i].comment !== undefined ? files[i].comment.controlNetModule : ""
                let controlNetModel = files[i].comment !== undefined ? files[i].comment.controlNetModel : ""
                let controlNetWeight = files[i].comment !== undefined ? files[i].comment.controlNetWeight : ""
                let ensd = files[i].comment !== undefined ? files[i].comment.ensd : ""
                let hiresUpscale = files[i].comment !== undefined ? files[i].comment.hiresUpscale : ""
                let hiresUpscaler = files[i].comment !== undefined ? files[i].comment.hiresUpscaler : ""
                let rawInfo = files[i].rawInfo !== undefined ? files[i].rawInfo : ""
                let vae = files[i].vae !== undefined ? files[i].vae : ""
                let gpu = files[i].gpu !== undefined ? files[i].gpu : ""
                let vram = files[i].vram !== undefined ? files[i].vram : ""
                let useAIGeneration = files[i].useAIGeneration ? 1 : 0
                if(typeof prompt === "string"){
                    if(!promptFound && (prompt.trim().length > 0 || negativePrompt.trim().length > 0)){
                        promptFound = true
                    }
                }
                fd.append("modelHash[]",modelHash)
                fd.append("prompt[]",prompt)
                fd.append("negativePrompt[]",negativePrompt)
                fd.append("noise[]",noise)
                fd.append("steps[]",steps)
                fd.append("scale[]",scale)
                fd.append("seed[]",seed)
                fd.append("sampler[]",sampler)
                fd.append("strength[]",strength)
                fd.append("maskBlur[]",maskBlur)
                fd.append("clipSkip[]",clipSkip)
                fd.append("controlNetEnabled[]",controlNetEnabled)
                fd.append("controlNetModule[]",controlNetModule)
                fd.append("controlNetModel[]",controlNetModel)
                fd.append("controlNetWeight[]",controlNetWeight)
                fd.append("ensd[]",ensd)
                fd.append("hiresUpscale[]",hiresUpscale)
                fd.append("hiresUpscaler[]",hiresUpscaler)
                fd.append("rawInfo[]",rawInfo)
                fd.append("vae[]",vae)
                fd.append("gpu[]",gpu)
                fd.append("vram[]",vram)
                fd.append("useAIGeneration[]",useAIGeneration)
            }
        }
        if(promptFound){
            description += " #プロンプトあり"
        }
        fd.append("description",description)
        if(loginInfo.result === false){
            fd.append("deletePassword",document.getElementById("delete-password").value)
        }
        fd.append("hobby",hobby)
        fd.append("notes",notes)
        fd.append("fanart",fanart)
        fd.append("fanartHashTag",fanartHashTag)
        fd.append("xId",xId)
        fd.append("youtubeId",youtubeId)
        fd.append("instagramId",instagramId)
        fd.append("tiktokId",tiktokId)
        fd.append("misskeyId",misskeyId)
        fd.append("discordUserName",discordUserName)
        fd.append("githubId",githubId)
        fd.append("huggingfaceId",huggingfaceId)
        fd.append("homepage",homepage)

        for(let i = 0;i < files.length;i++){
            fd.append("file[]",files[i].useMosaic === "1" ? base64ToFile(files[i].imageDataEdited.replace(/^.*,/, ''),files[i].file.name,"image/png") : files[i].file)
        }
        let req = new XMLHttpRequest()
        req.open("POST",ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/upload/character")
        req.withCredentials = true
        req.onreadystatechange = () => {
            if(req.readyState === 4 && req.status === 200){
                if(req.responseText !== ""){
                    var r = JSON.parse(req.responseText)
                    if(r.result){
                        let title = document.getElementById("title")
                        let titleValue = title.value

                        if(batch && fileList.length !== 1){
                            console.log(uploadProgressNo+1,fileList.length)
                            if(uploadProgressNo + 1 === fileList.length){
                                clearInterval(timer)
                                // 入力内容をリセット
                                deleteFormValue()
                                unsetDisabled()
                                setBatchProgressNow(0)
                                setBatchProgressLabel(0)
                                setBatchUploading(false)
                                setUploading(false)
                                dialog("確認","投稿完了しました。")
                                uploadProgressNo = 0
                                oldUploadProgressNo = 1
                            }
                        } else {
                            // 予約投稿でなければリンク共有メッセージを出す
                            if(bookingDate === ""){
                                // 投稿ID
                                setPostedGroupId(r.groupId)
                                // タグ
                                let tags = r.tags.filter(tag => {
                                    // 自動で追加するタグは除外する
                                    return tag !== "AIイラスト"
                                }).map(tag => "#" + tag).join(" ")
                                // サムネイルURL
                                setImgURL(ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+r.img)
                                // ツイートURL
                                setURL("https://twitter.com/intent/tweet?ref_src=twsrc%5Etfw%7Ctwcamp%5Ebuttonembed%7Ctwterm%5Emention%7Ctwgr%5Eourt_official&text="
                                    + encodeURIComponent("「アワートAI」AIイラスト無料生成&投稿サイトに投稿しました！\nキャラクター" + titleValue + "」\n" + ApiFetch.API_PROTOCOL+"//ourt-ai.work/character/"+r.groupId + "\n#アワートAI #AI術師さんと繋がりたい")
                                )
                            } else {
                                dialog("確認","予約投稿が完了しました。")
                            }
                            // 入力内容をリセット
                            deleteFormValue()
                            unsetDisabled()
                            // アップロード終了
                            setUploading(false)
                        }
                        setTempThumbnail()
                        setEventTag("")
                        uploadProgressNo++
                        // 入力準備チェック
                        setUploadReady(false)
                    } else {
                        clearInterval(timer)
                        unsetDisabled()
                        setBatchProgressNow(0)
                        setBatchProgressLabel(0)
                        setBatchUploading(false)
                        setUploading(false)
                        dialog("エラー",r.errors.join("\r\n"))
                    }
                    setProgressNow(0)
                    setProgressLabel(0)
                }
            }
        }
        req.onerror = (e) => {
            clearInterval(timer)
            setUploading(false)
            unsetDisabled()
            setProgressNow(0)
            setProgressLabel(0)
            setBatchProgressNow(0)
            setBatchProgressLabel(0)
            setBatchUploading(false)
            setUploading(false)
            console.log(e)
            dialog("エラー","通信エラーが発生しました。")
        }
        req.upload.onprogress = (e) => {
            let per = Math.floor(e.loaded / e.total * 100)
            let label = ""
            if(!batch && per === 100){
                label = "登録中"
            } else {
                label = per + "%"
            }
            setProgressNow(per)
            setProgressLabel(label)
        }
        req.send(fd)
    }

    // 画像設定
    const [fileList, setFileList] = useState([])
    const [fileSize, setFileSize] = useState(0)
    const [fileSizeByte, setFileSizeByte] = useState(0)
    const [fileSizeOver,setFileSizeOver] = useState(false)

    useEffect(() => {
        if(loginInfo.result === false){
            //navigate("/")
        }
        if(loginInfo.result && loginInfo.status !== 0){
            dialog(t("common.error"),"アカウントは利用できません。")
        }
        if(loginInfo.result){
            // シリーズ
            getSeriesList(loginInfo.userId).then(r => {
                if(r.result){
                    let list = []
                    for(let i = 0;i < r.data.length;i++){
                        list.push({"label":r.data[i].info.series_name,"id":r.data[i].info.series_id})
                    }
                    setSeriesList(list)
                }
            })
        }
    },[loginInfo])

    useEffect(() => {
        // お題
        getOdai().then(r => {
            if(r.result && r.data.length > 0){
                setOdai(r.data[0].odai)
            }
        })
        // ポイント
        getPoint().then(r => {
            if(r.result){
                setPoint(r.point)
            } else {
                dialog("エラー",r.errors)
            }
        })
        // 時間帯別利用者数
        getUsersByDay().then(r => {
            if(r.result){
                setUserList(<Bar data={createGraphData(r.data.list,"時間帯別利用者数")} />)
            }
        })
        // 最新タグ
        getTagLatest().then(r => {
            if(r.result){
                setTagLatest(r.data)
            }
        })
    },[])

    useEffect(() => {
        // タイトル設定
        document.querySelector("title").textContent = "画像投稿 AI画像生成 - ourt AI"

        // ファイルサイズ合計計算
        let size = 0
        for(let i = 0;i < fileList.length;i++){
            size += fileList[i].file.size
        }
        setFileSizeByte(size)
        size = size / 1024 / 1024 / 1024
        setFileSizeOver(size > 300)
        setFileSize(Math.ceil(size) + " GB")

        // 獲得ポイント計算
        calcPoint(fileList.length).then(r => {
            if(r.result){
                setCalcPointInfo(r.data)
            }
        })

        if(fileList.length > 0){
            document.getElementById("load-image").src = fileList[editImageNo].useMosaic ? fileList[editImageNo].imageDataEdited : fileList[editImageNo].imageDataMiddle
            if(selectedImageFilename !== fileList[editImageNo].file.name){
                //setInsideThumbnail()
                //setOutsideThumbnail()
                setSelectedImageFilename(fileList[editImageNo].file.name)
            }
            if(tempThumbnail === undefined){
                ImageUtil.load(fileList,fileList[0].file,0,(data,data2,data3)=>{
                    if(data !== false){
                        setInsideThumbnail((fileList[0].useMosaic ? fileList[0].imageDataEdited : fileList[0].imageDataMiddle) || data3)
                    }
                })
            }
        }
    },[fileList])

    // 調整用サムネイル
    const [insideThumbnail,setInsideThumbnail] = useState()   // 内部用
    const [outsideThumbnail,setOutsideThumbnail] = useState() // 外部用(OGP)
    const [tempThumbnail,setTempThumbnail] = useState()
    const [selectedImageFilename,setSelectedImageFilename] = useState()

    useEffect(() => {
        if(fileList.length > 0){
            document.getElementById("load-image").src = fileList[editImageNo].useMosaic ? fileList[editImageNo].imageDataEdited : fileList[editImageNo].imageDataMiddle
            //setInsideThumbnail()
            //setOutsideThumbnail()
            setSelectedImageFilename(fileList[editImageNo].file.name)
        }
    },[editImageNo])

    // 選択画像を検出してフォーム内容を切り替え
    useEffect(() => {
        if(editImageNo !== -1 && fileList.length > 0){
            setMetaDataField(fileList[editImageNo],true)
        }
    },[fileList,editImageNo])

    // 編集対象の画像を処理
    useEffect(() => {
        if(editImageTargetNo !== -1){
            let file = fileList[editImageTargetNo]
            setCanvas(file)
        }
    },[editImageTargetNo])

    function imageSet(files,isuseAIGeneration){
        setMessage('')
        setMessageShow("none")
        let fileList = []
        for(let i = 0;i < files.length;i++){
            //if(String(files[i].name).match(/\.(jpg|jpeg?|jfif|bmp|png|gif|webp)$/)){
                let img = new ImageFile({file:files[i]})
                if(isuseAIGeneration){
                    img.useAIGeneration = true
                }
                fileList.push(img)
                // AI生成画像の場合は情報を取得して最初の1件目をフィールドに反映
                setMetaData(files[i],img).then(r => {
                    if(i === 0) setMetaDataField(img,false)
                })
            //}
        }
        setEditImageNo(0)
        setFileList(fileList)
    }

    function imageAdd(files,isuseAIGeneration){
        setMessage('')
        setMessageShow("none")
        let list = fileList.concat([])
        for(let i = 0;i < files.length;i++){
            //if(String(files[i].name).match(/\.(jpg|jpe?|jfif|bmp|png|gif|webp)$/)){
                let img = new ImageFile({file:files[i]})
                if(isuseAIGeneration){
                    img.useAIGeneration = true
                }
                list.push(img)
                // AI生成画像の場合は情報を取得してフィールドに設定
                setMetaData(files[i],img).then(r => {

                })
            //}
        }
        setFileList(list)
    }

    /**
     * AIで作成された画像の生成情報を取得する
     * @todo 絵文字があるとextractChunksで読み込めない
     * 
     * @param {File} file 
     * @param {ImageFile} img 
     */
    function setMetaData(file,img){
        return file.arrayBuffer().then(buffer => {
            if(notReadPromptInfo) return
            try {
                let chunks = extractChunks(new Uint8Array(buffer))
                .filter(value => value.name === "tEXt" || value.name === "iTXt")
                .map((value) => {
                    let data = value.data
                    let text = new TextDecoder().decode(data)
                    let items = ["Description","Software","Source","Comment","parameters"]
                    let itemName
                    if(undefined !== (itemName = items.find((v) => text.startsWith(v)))){
                        return {name:itemName,value:text.substring(itemName.length+1)}
                    } else {
                        return {name:itemName,value:""}
                    }
                })
                .filter(value => value.name !== undefined)

                // Stable Diffusionならparametersがある
                let parameters = chunks.find(d => d.name === "parameters")
                if(parameters !== undefined && parameters.value !== ""){
                    img.rawInfo = parameters.value.replace(/[\x00]/g,'')
                    let split = parameters.value.split("\n")
                    let prompt = ""
                    let negativePrompt = ""
                    let options = ""
                    let negativeIndex = 0
                    for(let i = 1;i<split.length;i++){
                        if(split[i].startsWith("Negative prompt: ")){
                            negativePrompt = split[i].replace("Negative prompt: ","")
                            negativeIndex = i
                        }
                        if(split[i].startsWith("Steps:")){
                            options = split[i]
                        }
                    }
                    for(let i = 0;i< negativeIndex;i++){
                        prompt += split[i] + "\r\n"
                    }
                    prompt = prompt.replace(/[\x00]/g,'')
                    negativePrompt = negativePrompt.replace(/[\x00]/g,'')
                    options = options.replace(/[\x00]/g,'')
                    //prompt = prompt.replace(/ +/g,' ')
                    let params = []
                    for(const m of options.matchAll(/([a-zA-Z0-9 ]+): ([0-9a-zA-Z.\-_ +]+)?/g)){
                        if(m[2] !== undefined)
                        params.push({name:String(m[1]).trim(),value:m[2]})
                    }
                    // プロンプト
                    for(const m of options.matchAll(/([a-zA-Z0-9 ]+): "(.+?)"/g)){
                        if(m[2] !== undefined)
                        params.push({name:String(m[1]).trim(),value:m[2]})
                    }
                    if(split.length <= 1){
                        throw new Error("必要な情報が揃っていません。")
                    }
                    /*let params = options.split(",").map(d => {
                        let name
                        let value
                        let tmp
                        let item
                        tmp = d.trim()
                        item = tmp.split(":")
                        name = item[0]
                        value = item[1].substring(1)
                        console.log("4")
                        return {name:name,value:value}
                    })*/

                    img.prompt = prompt
                    let modelHash = params.find(d => d.name === "Model hash")
                    if(modelHash !== undefined){
                        img.software = "no-select"
                        if(modelHash.value === "6569e224"){
                            img.software = "AnythingV3"
                        } else if(
                               modelHash.value === "04c147f2" // v1.1 full
                            || modelHash.value === "4567aa0f" // v1.1
                            || modelHash.value === "11d755f8" // v1.2 full
                            || modelHash.value === "5e18682b" // v1.2
                            || modelHash.value === "ec706de4" // v1.3 full
                            || modelHash.value === "3706d7ad" // v1.3
                            || modelHash.value === "06c50424" // v1.4 full
                            || modelHash.value === "7460a6fa" // v1.4
                        ){
                            img.software = "StableDiffusion"
                        } else if(
                               modelHash.value === "84692140"   // v1.3 float16
                            || modelHash.value === "4470c325"   // v1.3 float32
                            || modelHash.value === "e1de58a9"   // v1.3 full
                            || modelHash.value === "3e1a125f"   // v1.3 full opt
                            || modelHash.value === "27310bc7"   // v1.4
                        ){
                            img.software = "WaifuDiffusion"
                        } else if(
                               modelHash.value === "e2ec4647" // 16
                            || modelHash.value === "3a0cfc1c" // 17
                        ){
                            img.software = "HentaiDiffusion"
                        } else if(
                               modelHash.value === "abaf1da6" // ACertainModel-half
                            || modelHash.value === "0ea1c8b4" // ACertainModel
                        ){
                            img.software = "ACertainModel"
                        } else if(
                            modelHash.value === "27bd26ec" // ACertainThing-half
                         || modelHash.value === "26f53cad" // ACertainThing
                        ){
                            img.software = "ACertainThing"
                        } else if(
                               modelHash.value === "0e200e66" // ACertainty
                        ){
                            img.software = "ACertainty"
                        } else if(modelHash.value === "1449e5b0b9"){
                            img.software = "Animagine XL V3"
                        } else if(modelHash.value === "b5c0b653"){
                            img.software = "Protogen"
                        } else if(modelHash.value === "fde2460c"){ 
                            img.software = "ourtAIDiffusion" // V1.0
                        } else if(modelHash.value === "4048130a"){
                            img.software = "Counterfeit" // V2.0
                        } else if(modelHash.value === "8838e0d1fb"){
                            img.software = "Counterfeit" // V2.0
                        } else if(modelHash.value === "f3b033b02f"){
                            img.software = "Counterfeit" // V2.0
                        } else if(modelHash.value === "71e703a0fc"){
                            img.software = "Counterfeit" // V2.5
                        } else if(modelHash.value === "fc9d6d1ff2"){
                            img.software = "SukiyakiMix" // v1.0
                        } else if(modelHash.value === "6e350084a6"){
                            img.software = "7th_anime" // 7th_anime_3.1_A
                        } else if(modelHash.value === "a916690d6d"){
                            img.software = "ourt AI Diffusion (Anime V1)" // Anime V1
                        } else if(modelHash.value === "7a5574856e"){
                            img.software = "ourt AI Diffusion (Anime V2)" // Anime V2
                        } else if(modelHash.value === "09184cfb61"){
                            img.software = "ourt AI Diffusion (Anime V3)" // Anime V3
                        } else if(modelHash.value === "c53b90ad34"){
                            img.software = "ourt AI Diffusion (Anime V3.5)" // Anime V3.5
                        } else if(modelHash.value === "1b5f8211ec"){
                            img.software = "Aurora_v1.0" // Aurora v1.0
                        } else if(modelHash.value === "6772b99463"){
                            img.software = "blue_pencil_v9b" // blue_pencil_v9b
                        } else if(modelHash.value === "3a105af1a6"){
                            img.software = "blue_pencil_v10" // blue_pencil_v10
                        } else if(modelHash.value === "0fd9832365"){
                            img.software = "blue_pencil_EX" // blue_pencil_EX
                        } else if(modelHash.value === "b1fce039e2"){
                            img.software = "milktea_mild_V1" // milktea_mild_V1
                        } else if(modelHash.value === "e4a30e4607"){
                            img.software = "majicmixRealistic_v6"
                        } else {
                            let model = params.find(d => d.name === "Model")
                            if(model !== undefined){
                                img.software = model.value
                            }
                            img.modelHash = modelHash.value
                        }

                        img.modelHash = modelHash.value

                    } else {
                        img.software = "no-select"
                        let model = params.find(d => d.name === "Model")
                        if(model !== undefined){
                            img.software = model.value
                        } else {
                            throw new Error("unsupported model")
                        }
                    }

                    let steps = params.find(d => d.name === "Steps")
                    let scale = params.find(d => d.name === "CFG scale")
                    let seed = params.find(d => d.name === "Seed")
                    let sampler = params.find(d => d.name === "Sampler")
                    let denoisingStrength = params.find(d => d.name === "Denoising strength")
                    let maskBlur = params.find(d => d.name === "Mask blur")
                    let clipSkip = params.find(d => d.name === "Clip skip")
                    let controlNetEnabled = params.find(d => d.name === "ControlNet Enabled")
                    let controlNetModule = params.find(d => d.name === "ControlNet Module")
                    let controlNetModel = params.find(d => d.name === "ControlNet Model")
                    let controlNetWeight = params.find(d => d.name === "ControlNet Weight")
                    let ensd = params.find(d => d.name === "ENSD")
                    let hiresUpscale = params.find(d => d.name === "Hires upscale")
                    let hiresUpscaler = params.find(d => d.name === "Hires upscaler")

                    img.comment = {
                        uc:negativePrompt,
                        noise:"",
                        steps:steps === undefined ? "" : steps.value,
                        scale:scale === undefined ? "" : scale.value,
                        seed:seed === undefined ? "" : seed.value,
                        sampler:sampler === undefined ? "" : sampler.value,
                        // img2imgの場合はDenoising strengthとMask blurも追加
                        strength:denoisingStrength === undefined ? "" : denoisingStrength.value,
                        maskBlur:maskBlur === undefined ? "" : maskBlur.value,
                        clipSkip:clipSkip === undefined ? "" : clipSkip.value,
                        controlNetEnabled:controlNetEnabled === undefined ? "" : controlNetEnabled.value,
                        controlNetModule:controlNetModule === undefined ? "" : controlNetModule.value,
                        controlNetModel:controlNetModel === undefined ? "" : controlNetModel.value,
                        controlNetWeight:controlNetWeight === undefined ? "" : controlNetWeight.value,
                        ensd:ensd === undefined ? "" : ensd.value,
                        hiresUpscale:hiresUpscale === undefined ? "" : hiresUpscale.value,
                        hiresUpscaler:hiresUpscaler === undefined ? "" : hiresUpscaler.value,
                        vae:"",
                        gpu:"",
                        vram:""
                    }
                    return
                }

                // softwareがNovelAIの場合
                let software = chunks.find(d => d.name === "Software")
                let source = chunks.find(d => d.name === "Source")
                let description = chunks.find(d => d.name === "Description")
                let comment = chunks.find(d => d.name === "Comment")

                if(source !== undefined && source.value.split(" ").length === 3){
                    img.modelHash = source.value.split(" ")[2]
                }
                if(software !== undefined && software.value === "NovelAI"){
                    img.prompt = description === undefined ? "" : description
                    img.software = software.value
                    img.useAIGeneration= false
                    img.rawInfo = ""
                    img.vae = ""
                    img.gpu = ""
                    img.vram = ""
                    if(comment !== undefined && comment.value !== ""){
                        let j = JSON.parse(comment.value)
                        img.comment = {uc:j.uc,noise:j.noise,steps:j.steps,scale:j.scale,seed:j.seed,sampler:j.sampler,strength:j.strength,maskBlur:"",
                        clipSkip:"",controlNetEnabled:"",controlNetModule:"",controlNetModel:"",controlNetWeight:"",ensd:"",hiresUpscale:"",hiresUpscaler:""}
                    }
                }
            } catch(e) {
                img.prompt = ""
                img.software = "no-select"
                img.modelHash = ""
                img.vae = ""
                img.gpu = ""
                img.vram = ""
                img.comment = {uc:"",noise:"",steps:"",scale:"",seed:"",sampler:"",strength:"",maskBlur:"",
                clipSkip:"",controlNetEnabled:"",controlNetModule:"",controlNetModel:"",controlNetWeight:"",
                ensd:"",hiresUpscale:"",hiresUpscaler:"",rawInfo:"",useAIGeneration:false}
            }
        })
    }

    /**
     * 表示中のフィールドにメタデータを反映する
     * 
     * @param {ImageFile} img 
     * @param {bool} override
     */
    function setMetaDataField(img,override){
        let aiModel = document.getElementById("ai-model")
        let modelVersion = document.getElementById("model-version")
        let prompt = document.getElementById("prompt")
        let negativePrompt = document.getElementById("negative-prompt")
        let noise = document.getElementById("noise")
        let steps = document.getElementById("steps")
        let scale = document.getElementById("scale")
        let seed = document.getElementById("seed")
        let sampler = document.getElementById("sampler")
        let strength = document.getElementById("strength")
        let maskBlur = document.getElementById("mask-blur")
        let clipSkip = document.getElementById("clip-skip")
        let controlNetEnabled = document.getElementById("controlnet-enabled")
        let controlNetModule = document.getElementById("controlnet-module")
        let controlNetModel = document.getElementById("controlnet-model")
        let controlNetWeight = document.getElementById("controlnet-weight")
        let ensd = document.getElementById("ensd")
        let hiresUpscale = document.getElementById("hires-upscale")
        let hiresUpscaler = document.getElementById("hires-upscaler")
        let rawInfo = document.getElementById("raw-info")

        if(override || (aiModel.value === "no-select" && img.software !== "")){
            aiModel.value = img.software
        }
        let versions = {
            "1D44365E":"NAI Diffusion Anime (Curated)",
            "81274D13":"NAI Diffusion Anime (Full)",
            "1D09D794":"NAI Diffusion Furry (Beta V1.3)",
            "04c147f2":"v1.1 full ema", // Stable Diffusion～
            "4567aa0f":"v1.1",          
            "11d755f8":"v1.2 full ema",
            "5e18682b":"v1.2",
            "ec706de4":"v1.3 full ema",
            "3706d7ad":"v1.3",
            "06c50424":"v1.4 full ema",
            "7460a6fa":"v1.4",          // ～Stable Diffusion
            "84692140":"v1.3 float16",  // Waifu Diffusion～
            "4470c325":"v1.3 float32",
            "e1de58a9":"v1.3 full",
            "3e1a125f":"v1.3 full opt",
            "27310bc7":"v1.4",          // ～Waifu Diffusion
            "e2ec4647":"16",            // HentaiDiffusion
            "3a0cfc1c":"17",            // HentaiDiffusion
            "abaf1da6":"half",          // ACertainModel-half
            "27bd26ec":"half",          // ACertainThing-half
            "1449e5b0b9":"V3",
            "b5c0b653":"V2.2 (Anime)",  // Protogen V2.2 (Anime)
            "fde2460c":"V1.0",          // ourtAI Diffusion V1.0
            "4048130a":"V2.0",          // Counterfeit V2.0
            "8838e0d1fb":"V2.0",        // Counterfeit V2.0
            "f3b033b02f":"V2.0",        // Counterfeit V2.0
            "71e703a0fc":"V2.5",        // Counterfeit V2.5
            "fc9d6d1ff2":"v1.0 fp16",   // SukiyakiMix v1.0
            "6e350084a6":"anime_3.1_A", // 7th_anime_3.1_A
            "a916690d6d":"Anime V1",    // ourt AI Diffusion Anime V1
            "7a5574856e":"Anime V2",    // ourt AI Diffusion Anime V2
            "09184cfb61":"Anime V3",    // ourt AI Diffusion Anime V3
            "c53b90ad34":"Anime V3.5",  // ourt AI Diffusion Anime V3.5
            "1b5f8211ec":"v1.0 F16",    // Aurora v1.0
            "6772b99463":"v9b",         // blue_pencil_v9b
            "3a105af1a6":"v10",         // blue_pencil_v10
            "0fd9832365":"EX",          // blue_pencil_EX
            "b1fce039e2":"V1",          // milktea_mild_V1
            "e4a30e4607":"v6"           // majicmixRealistic_v6
        }
        if(override || (modelVersion.value === "" && img.modelHash !== "")){
            if(versions[img.modelHash]){
                modelVersion.value = versions[img.modelHash]
            } else {
                modelVersion.value = ""
            }
        }
        if(override || (prompt.value === "" && img.prompt)){
            prompt.value = img.prompt
        }
        if(override || (negativePrompt.value === ""  && img.comment && img.comment.uc)){
            negativePrompt.value = img.comment.uc
        }
        if(override || (noise.value === ""  && img.comment && img.comment.noise)){
            noise.value = img.comment.noise
        }
        if(override || (steps.value === ""  && img.comment && img.comment.steps)){
            steps.value = img.comment.steps
        }
        if(override || (scale.value === ""  && img.comment && img.comment.scale)){
            scale.value = img.comment.scale
        }
        if(override || (seed.value === ""  && img.comment && img.comment.seed)){
            seed.value = img.comment.seed
        }
        if(override || (sampler.value === ""  && img.comment && img.comment.sampler)){
            sampler.value = img.comment.sampler
        }
        if(override || (strength.value === ""  && img.comment && img.comment.strength)){
            strength.value = img.comment.strength
        }
        if(override || (maskBlur.value === ""  && img.comment && img.comment.maskBlur)){
            maskBlur.value = img.comment.maskBlur
        }
        if(override || (clipSkip.value === ""  && img.comment && img.comment.clipSkip)){
            clipSkip.value = img.comment.clipSkip
        }
        if(override || (controlNetEnabled.value === ""  && img.comment && img.comment.controlNetEnabled)){
            controlNetEnabled.value = img.comment.controlNetEnabled
        }
        if(override || (controlNetModule.value === ""  && img.comment && img.comment.controlNetModule)){
            controlNetModule.value = img.comment.controlNetModule
        }
        if(override || (controlNetModel.value === ""  && img.comment && img.comment.controlNetModel)){
            controlNetModel.value = img.comment.controlNetModel
        }
        if(override || (controlNetWeight.value === ""  && img.comment && img.comment.controlNetWeight)){
            controlNetWeight.value = img.comment.controlNetWeight
        }
        if(override || (ensd.value === ""  && img.comment && img.comment.ensd)){
            ensd.value = img.comment.ensd
        }
        if(override || (hiresUpscale.value === ""  && img.comment && img.comment.hiresUpscale)){
            hiresUpscale.value = img.comment.hiresUpscale
        }
        if(override || (hiresUpscaler.value === ""  && img.comment && img.comment.hiresUpscaler)){
            hiresUpscaler.value = img.comment.hiresUpscaler
        }
        if(override || (rawInfo.value === "" && img.rawInfo)){
            rawInfo.value = img.rawInfo
        }
        if(override || img.vae){
            setVAE([img.vae])
        }
        if(override || img.gpu){
            setGPU([img.gpu])
        }
        if(override || img.vram){
            setVRAM([img.vram])
        }
    }

    // ダイアログ
    const [show, setShow] = useState(false)
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogMessage, setDialogMessage] = useState("")
    const [dialogButton,setDialogButton] = useState()
    function dialog(title,message,button){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
        setDialogButton(button)
    }

    // エラーメッセージ
    const [message, setMessage] = useState('')
    const [messageShow, setMessageShow] = useState('none')

    const [title, setTitle] = useState('')
    const [characterName, setCharacterName] = useState('')
    const [characterNameKana, setCharacterNameKana] = useState('')
    const [ageLimit, setAgeLimit] = useState('')
    const [characterAge, setCharacterAge] = useState('')
    const [sexualExpression,setSexualExpression] = useState('')
    const [styleOfPainting, setStyleOfPainting] = useState('')
    const [hobby, setHobby] = useState('')
    const [notes, setNotes] = useState('')
    const [fanart, setFanart] = useState('')
    const [characterSex, setCharacterSex] = useState('')
    const [sdStyleOfPainting, setSdStyleOfPainting] = useState('all')
    const [scaleTargetStyle, setScaleTargetStyle] = useState('illustration')
    const [fanartHashTag, setFanartHashTag] = useState('')
    const [xId, setXId] = useState('')
    const [youtubeId, setYouTubeId] = useState('')
    const [instagramId, setInstagramId] = useState('')
    const [tiktokId, setTiktokId] = useState('')
    const [misskeyId, setMisskeyId] = useState('')
    const [discordUserName, setDiscordUserName] = useState('')
    const [githubId, setGitHubId] = useState('')
    const [huggingfaceId, setHuggingFaceId] = useState('')
    const [homepage, setHomepage] = useState('')
    const [vae, setVAE] = useState()
    const [gpu, setGPU] = useState()
    const [vram, setVRAM] = useState()

    const nenrei = [
      { name: t("upload.image.ageLimitG"), value: '1' },
      { name: t("upload.image.ageLimitPG12"), value: '2' },
      { name: t("upload.image.ageLimitR15"), value: '3' },
      { name: t("upload.image.ageLimitR18"), value: '4' },
      { name: t("upload.image.ageLimitR18G"), value: '5' }
    ]

    const radioKoukai = [
        { name: '全体公開', value: '1' },
        { name: '限定公開', value: '2' },
        { name: '非公開', value: '3' }
    ]

    const styles = [
        { name: t("upload.image.illustration"), value: '1' },
        { name: t("upload.image.semirealism"), value: '3' },
        { name: t("upload.image.photorealistic"), value: '2' },
    ]

    const sexRadio = [
        { name: "男", value: '1' },
        { name: "女", value: '2' },
        { name: "その他", value: '3' },
    ]

    const yesOrNoRadio = [
        { name: t("common.no"), value: "2" },
        { name: t("common.yes"), value: "1" },
    ]
    const [unitAmount,setUnitAmount] = useState(0)
    const [limitDiv,setLimitDiv] = useState("public")
    const [selectionPlans,setSelectionPlans] = useState([])
    const columns = [
        { field: 'name', headerName: 'プラン名', width: 130, sortable: false, disableColumnMenu: true },
        { field: 'amount', headerName: '月額', width: 130, sortable: false, disableColumnMenu: true },
        {
          field: 'count',
          headerName: '支援者数',
          type: 'number',
          width: 90,
          sortable: false,
          disableColumnMenu: true
        },
        { field: 'age_limit', headerName: '年齢制限', width: 130, sortable: false, disableColumnMenu: true },
    ]  
    const [rows,setRows] = useState([])
    const [birthdaySet,setBirthdaySet] = useState("2")
    const [month,setMonth] = useState()
    const [day,setDay] = useState()

    useEffect(() => {
        if(birthdaySet === "1"){
            setMonth()
            setDay()
        } else {
            setMonth()
            setDay()
        }
    },[birthdaySet])

    function sendFileList(file){
        if(fileList.length === 0){
            imageSet([file],true)
        } else {
            imageAdd([file],true)
        }
        setEditImageNo(fileList.length)
        alert("投稿一覧に追加しました。")
    }
    const [serverStatus,setServerStatus] = useState([])
    const [before2SDTestCount,setBefore2SDTestCount] = useState(0)
    const [before24SDAllCount,setBefore24SDAllCount] = useState(0)
    const [before24DALLE3Count,setBefore24DALLE3Count] = useState(0)
    const [before24SD3Count,setBefore24SD3Count] = useState(0)
    const [srcGroupId,setSrcGroupId] = useState("")
    const [srcDetailId,setSrcDetailId] = useState("")
    const [srcTitle,setSrcTitle] = useState("")
    const [srcFavorite,setSrcFavorite] = useState("")
    const [generateProgress,setGenerateProgress] = useState(0)
    const [showGeneratedPanel,setShowGeneratedPanel] = useState(false)
    const [generatedInfo,setGeneratedInfo] = useState()
    const [generatedImageFile,setGeneratedImageFile] = useState()
    const [generatedImage,setGeneratedImage] = useState()
    const [generatedImageBase64,setGeneratedImageBase64] = useState()
    const [showGeneratedInfo,setShowGeneratedInfo] = useState(false)
    const [deleteCheckCount,setDeleteCheckCount] = useState(0)
    const [selectMode,setSelectMode] = useState(false)
    const [generateZoom,setGenerateZoom] = useState(false)
    const [generateSettingShow,setGenerateSettingShow] = useState(false)
    useEffect(() => {
        let count = 0
        document.querySelectorAll(".delete-check").forEach(input => {
            if(input !== undefined && input.checked){
                count++
            }
        })
        // 一括選択されている場合
        setSelectMode(aiGenerateImageList.length == count && count > 0)
        console.log(aiGenerateImageList.length,count)
    },[deleteCheckCount])
    const keyEvent = (e) => {
        if(showGeneratedInfo && e.key === "Escape"){
            setShowGeneratedInfo(false)
        }
    }
    document.onkeydown = keyEvent
    function isSmartPhone() {
        if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
            return true;
        } else {
            return false;
        }
    }
    function statusCountUpdate(){
        getStatusCount().then(r =>{
            setServerStatus([])
            let aiProccessingButton = document.querySelectorAll(".ai-proccessing-button")
            let info = document.querySelectorAll(".ai-proccessing-info")
            if(!r.result){
                aiProccessingButton.forEach(e => e.removeAttribute("disabled"))
            }
            if(r.data === undefined || r.data.status === undefined){
                return
            }
            if(r.data.status === 1 || r.data.status === 2){
                setAiProccessing(() => true)
                aiProccessingButton.forEach(e => e.setAttribute("disabled",true))
            }
            if(r.data.status === 1){
                info.forEach(e => e.innerText = " " + r.data.count + "枚が待機中です。予想残:"+r.data.time+"分")
                procId = r.data.procId
            } else if(r.data.status === 2) {
                info.forEach(e => e.innerText = "予想残:"+r.data.time+"分")
                procId = r.data.procId
                setGenerateProgress(r.data.progress)
            } else if(r.data.status === 0){
                info.forEach(e => e.innerText = "")
                setGenerateProgress(0)
                // 1または2のレコードがなく、現在処理中のproc_idがある場合はその後のステータスを取得する
                if(procId !== ""){
                    clearAllInterval()
                    getStatus(procId).then(r => {
                        if(r.data.status === 3) {
                            setGenerateProgress(100)
                            info.forEach(e => e.innerText = " 生成完了")
                            //let imageFile = base64ToFile(r.data.base64img.replace(/^.*,/, ''),procId + ".png","image/png")
                            setSrcGroupId(r.data.src_group_id)
                            setSrcDetailId(r.data.src_detail_id)
                            setSrcTitle(r.data.src_title)
                            setSrcFavorite(r.data.src_favorite)
                            //setReceivedImageFile(imageFile)
                            clearAllInterval()
                            setAiProccessing(false)
                            aiProccessingButton.forEach(e => e.removeAttribute("disabled"))
                            procId = ""
                            /*ImageUtil.load(undefined,imageFile,0,(data1,data2,base64) => {
                                setGenerateProgress(0)
                                setShowGeneratedPanel(true)
                                setGeneratedInfo(r.data)
                                setGeneratedImageFile(imageFile)
                                setGeneratedImage(data1)
                                setGeneratedImageBase64(base64)
                                aiProccessingCall()
                            })*/
                            setGenerateProgress(0)
                            if(isSmartPhone()){
                                setShowGeneratedPanel(true)
                                setGeneratedInfo(r.data)
                            }
                            aiProccessingCall()

                            // 生成履歴再取得
                            setAIGenerateReset(!aiGenerateReset)
                            setAIGenerateImagePage(1)
                        } else if(r.data.status === 4) {
                            if(r.data.api_status != 0){
                                if(r.data.api_status == 1){
                                    info.forEach(e => e.innerText = " 処理失敗:プロンプトが拒否されました。これが誤りではない場合、もう一度お試しください。")
                                }
                                if(r.data.api_status == 2){
                                    info.forEach(e => e.innerText = " 処理失敗:システムに生成結果の画像の内容がブロックされました。")
                                }
                                if(r.data.api_status == 400){
                                    info.forEach(e => e.innerText = " 処理失敗：リクエスト無効")
                                }
                                if(r.data.api_status == 403){
                                    info.forEach(e => e.innerText = " 処理失敗：プロンプトが拒否されました。")
                                }
                                if(r.data.api_status == 429){
                                    // 10秒間に150を超える場合
                                    info.forEach(e => e.innerText = " 処理失敗：リクエストが多すぎるため拒否されました。")
                                }
                                if(r.data.api_status == 500){
                                    info.forEach(e => e.innerText = " 処理失敗：連携先のシステムでエラーが発生しました。")
                                }
                            } else {
                                info.forEach(e => e.innerText = " 処理失敗")
                            }
                            clearAllInterval()
                            setAiProccessing(() => false)
                            aiProccessingButton.forEach(e => e.removeAttribute("disabled"))
                            procId = ""
                        } else if(r.data.status === 5) {
                            info.forEach(e => e.innerText = " 処理中断")
                            clearAllInterval()
                            setAiProccessing(() => false)
                            aiProccessingButton.forEach(e => e.removeAttribute("disabled"))
                            procId = ""
                        } else if(r.data.status === 6) {
                            if(loginInfo.age18 === 1){
                                info.forEach(e => e.innerHTML = " 生成結果がブロックされました。NSFWの生成は<a href='/generate_unlimit'>コイン決済</a>をご利用ください。")
                            } else {
                                info.forEach(e => e.innerText = " 生成結果がブロックされました。")
                            }
                            clearAllInterval()
                            setAiProccessing(() => false)
                            aiProccessingButton.forEach(e => e.removeAttribute("disabled"))
                            procId = ""
                        }
                        if(r.data.status === 4 || r.data.status === 5){
                            getPoint().then(r => {
                                if(r.result){
                                    setPoint(r.point)
                                }
                            })
                        }
                    })
                }
                setServerStatus(r.data)
                setBefore2SDTestCount(r.data.servers.before24SD)
                setBefore24SDAllCount(r.data.servers.before24SDAll)
                setBefore24DALLE3Count(r.data.servers.before24DALLE3)
                setBefore24SD3Count(r.data.servers.before24SD3)
            }
        })
    }
    function base64ToFile(base64,filename,mime){
        let bin = atob(base64.replace(/^.*,/, ''));
        let buffer = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; i++) {
            buffer[i] = bin.charCodeAt(i);
        }
        return new File([buffer.buffer], filename, {type: mime});
    }
    function download(blob){
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a")
        document.body.appendChild(a)
        a.download = 'foo.pdf'
        a.href = url
        a.click()
    }
    function aiProccessingCall(){
        let aiProccessingButton = document.querySelectorAll(".ai-proccessing-button")
        getPoint().then(r => {
            if(r.result){
                setPoint(r.point)
                aiProccessingButton.forEach(e => e.removeAttribute("disabled"))
            } else {
                dialog("エラー",r.errors)
                aiProccessingButton.forEach(e => e.setAttribute("disabled",false))
            }
        })
        getStatusCount().then(r =>{
            statusCountUpdate()
            if(r.result){
                setInterval(() =>{
                    statusCountUpdate()
                },3000)
            } else {
                setAiProccessing(() => false)
                aiProccessingButton.forEach(e => e.setAttribute("disabled",false))
            }
        })
    }
    function clearAllInterval(){
        for (var i = 1; i < 99999; i++)
            window.clearInterval(i)
    }
    function setCanvas(file){
        let data = file.useMosaic === "1" ? file.imageDataEdited : file.imageDataOriginal
        let canvas = document.createElement("canvas")
        canvas.id = "canvas"
        let ctx = canvas.getContext("2d")

        let img = document.createElement("img")
        img.src = data
        img.onload = () => {
            let w = 0
            let h = 0
            if(img.naturalWidth > img.naturalHeight){
                w = window.innerWidth
                h = img.naturalHeight * (window.innerWidth / img.naturalWidth)
            } else {
                w = img.naturalWidth * ((window.innerHeight - 110) / img.naturalHeight)
                h = window.innerHeight - 110
            }
            w = img.naturalWidth
            h = img.naturalHeight
            canvas.width = w
            canvas.height = h
            //canvas.style.border = "5px solid #FFFFFF"
            canvas.style.zIndex = "5"
            canvas.style.margin = "0"
            canvas.style.padding = "0"
            canvas.onmouseup = (e) => canvasMouseUp(e)
            canvas.onmousedown = (e) => canvasMouseDown(e)
            canvas.onmousemove = (e) => canvasMouseMove(e)

            ctx.drawImage(img,0,0,img.naturalWidth,img.naturalHeight,0,0,w,h)
            document.getElementById("canvas-area").textContent = ""
            document.getElementById("canvas-area").append(canvas)

            if(file.useMosaic === "1"){
                let originalImage = document.createElement("img")
                originalImage.src = file.imageDataOriginal
                originalImage.onload = () => {
                    setOriginalImage(originalImage)
                }
            } else {
                setOriginalImage(img)
            }
            // モザイクサイズの最小値を長辺の1/10にする
            let mosaicStrength = parseInt(getMosaicStrength())
            let minMosaicStrength = parseInt((w > h ? w : h) / 100)
            if(mosaicStrength < minMosaicStrength){
                mosaicStrength = minMosaicStrength
                setMosaicStrength(mosaicStrength)
            }
            setMinMosaicStrength(minMosaicStrength)
            setMosaicImage()
        }
        return true
    }
    function setMosaicImage(){
        let originalImage = getOriginalImage()
        let ctx = originalImage.getContext("2d")

        let mosaicCanvas = document.getElementById("mosaic-image")
        mosaicCanvas.width = originalImage.width
        mosaicCanvas.height = originalImage.height
        let mosaicCtx = mosaicCanvas.getContext("2d")

        let imgData = ctx.getImageData(0, 0, originalImage.width, originalImage.height)
        if (imgData !== "") {
            if(getMosaicStyle() === "dot"){
                let mosaicSize = parseInt(getMosaicStrength(), 10)
                for (let y = 0; y < imgData.height; y+=mosaicSize) {
                    for (let x = 0; x < imgData.width; x+=mosaicSize) {
                        let cR = imgData.data[(y * imgData.width + x) * 4]
                        let cG = imgData.data[(y * imgData.width + x) * 4 + 1]
                        let cB = imgData.data[(y * imgData.width + x) * 4 + 2]
                        mosaicCtx.fillStyle = "rgb("+cR+","+cG+","+cB+")"
                        mosaicCtx.fillRect(x,y,x + mosaicSize,y + mosaicSize)
                    }
                }
            } else if(getMosaicStyle() === "blur"){
                let tempImg = document.createElement("canvas")
                tempImg.width = originalImage.width
                tempImg.height = originalImage.height
                let imageData = ctx.getImageData(0,0,originalImage.width,originalImage.height)
                let tempCtx = tempImg.getContext("2d")
                tempCtx.putImageData(imageData,0,0)

                mosaicCtx.filter = "blur(" + getMosaicStrength() + "px)"
                mosaicCtx.drawImage(tempImg,0,0)
            }
        }
    }
    function mosaicCanvas(){
        setImageEditFlag(1)
        let drawCanvas = document.getElementById("canvas")
        let ctx = drawCanvas.getContext("2d")

        let mosaicCanvas = document.getElementById("mosaic-image")
        let mosaicCtx = mosaicCanvas.getContext("2d")

        let mosaicImgData = mosaicCtx.getImageData(0, 0, drawCanvas.width, drawCanvas.height)
        ctx.putImageData(mosaicImgData,0, 0)
    }
    function getMosaicImage() {
        return document.getElementById("mosaic-image")
    }
    let mousePress = false
    function canvasMouseUp(e) {
        mousePress = false
    }
    function canvasMouseDown(e) {
        mousePress = true
        canvasMouseMove(e)
    }
    function setDrawFlag(flag){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.selectdrawflag = flag
    }
    function getDrawFlag(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.selectdrawflag
    }
    function setOriginalImage(img){
        let original = document.getElementById("original-image")
        original.width = img.naturalWidth
        original.height = img.naturalHeight
        let originalCtx = original.getContext("2d")
        // console.log(img.naturalWidth,img.naturalHeight)
        originalCtx.drawImage(img,0,0,img.naturalWidth,img.naturalHeight,0,0,img.naturalWidth,img.naturalHeight)
    }
    function getOriginalImage(){
        return document.getElementById("original-image")
    }
    function setMosaicSize(size){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.mosaicsize = size
    }
    function getMosaicSize(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.mosaicsize
    }
    function setMosaicStrength(strength){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.mosaicstrength = strength
        document.querySelector("#mosaic-strength").value = strength
    }
    function getMosaicStrength(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.mosaicstrength
    }
    function setMosaicStyle(style){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.mosaicstyle = style
    }
    function getMosaicStyle(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.mosaicstyle
    }
    function canvasMouseMove(e) {
        if(!mousePress) return
        let drawFlag = getDrawFlag()
        let mosaicSize = getMosaicSize()
        // 描画モード
        if(drawFlag === "1"){
            setImageEditFlag(1)
            let client = e.currentTarget.getBoundingClientRect()
            // console.log(e.pageY,client.top,client.y,window.scrollY)
            let x = e.pageX - client.x - window.scrollX - mosaicSize / 2
            let y = e.pageY - client.y - window.scrollY - mosaicSize / 2

            let mosaicImageCtx = getMosaicImage().getContext("2d")
            let ctx = e.currentTarget.getContext("2d")

            let imageData = mosaicImageCtx.getImageData(x,y,mosaicSize,mosaicSize)
            ctx.putImageData(imageData,x,y)
        }
        // 消しゴムモード
        if(drawFlag === "2"){
            setImageEditFlag(1)
            let client = e.currentTarget.getBoundingClientRect()
            let x = e.pageX - client.x - mosaicSize / 2
            let y = e.pageY - client.y - mosaicSize / 1

            let ctx = e.currentTarget.getContext("2d")
            ctx.drawImage(getOriginalImage(),x,y,mosaicSize,mosaicSize,x,y,mosaicSize,mosaicSize)
        }
    }
    function resetCanvas() {
        setImageEditFlag(0)
        let canvas = document.getElementById("canvas")
        let ctx = canvas.getContext("2d")
        let img = document.createElement("img")
        img.src = fileList[editImageTargetNo].imageDataOriginal
        img.onload = () => {
            ctx.drawImage(img,0,0)
        }
    }
    // 変更内容を保存
    function saveEdit() {
        fileList[editImageTargetNo].useMosaic = getImageEditFlag()
        fileList[editImageTargetNo].imageDataEdited = document.getElementById("canvas").toDataURL("image/png")
        setFileList(fileList.concat())
        setInsideThumbnail()
        setOutsideThumbnail()
        setSelectedImageFilename()
        setEditImageTargetNo(-1)
    }
    // 保存せず閉じる
    function closeEdit() {
        setEditImageTargetNo(-1)
    }
    function setImageEditFlag(flag){
        let canvasArea = document.getElementById("canvas-area")
        canvasArea.dataset.imageeditflag = flag
    }
    function getImageEditFlag(){
        let canvasArea = document.getElementById("canvas-area")
        return canvasArea.dataset.imageeditflag
    }
    let costList = [
        {width:"512",height:"512",cost:5,stepsPer:1,stepsLimit:150,coinCost:10},
        {width:"768",height:"768",cost:10,stepsPer:2,stepsLimit:150,coinCost:14},
        {width:"1152",height:"1152",cost:35,stepsPer:7,stepsLimit:150,coinCost:20},
        {width:"1536",height:"1536",cost:70,stepsPer:21,stepsLimit:150,coinCost:56},

        {width:"384",height:"768",cost:7,stepsPer:1,stepsLimit:150,coinCost:10},
        {width:"512",height:"768",cost:7,stepsPer:1,stepsLimit:150,coinCost:12},
        {width:"768",height:"1152",cost:15,stepsPer:5,stepsLimit:150,coinCost:17},
        {width:"768",height:"1536",cost:25,stepsPer:7,stepsLimit:150,coinCost:25},
        {width:"1024",height:"1536",cost:30,stepsPer:10,stepsLimit:150,coinCost:30},

        {width:"768",height:"384",cost:7,stepsPer:1,stepsLimit:150,coinCost:10},
        {width:"768",height:"512",cost:7,stepsPer:1,stepsLimit:150,coinCost:12},
        {width:"1152",height:"768",cost:15,stepsPer:5,stepsLimit:150,coinCost:17},
        {width:"1536",height:"768",cost:25,stepsPer:7,stepsLimit:150,coinCost:25},
        {width:"1536",height:"1024",cost:30,stepsPer:10,stepsLimit:150,coinCost:30},

        {width: "480",height: "270",cost: 15,stepsPer: 5,coinCost: 8},
        {width: "960",height: "540",cost: 15,stepsPer: 5,coinCost: 15},
        {width:"1280",height:"720",cost:15,stepsPer:5,stepsLimit:150,coinCost:17},
        {width:"1600",height:"900",cost:30,stepsPer:10,stepsLimit:150,coinCost:25},
        {width:"1920",height:"1080",cost:45,stepsPer:15,stepsLimit:150,coinCost:40},

        {width:"270",height:"480",cost:15,stepsPer:5,coinCost:8},
        {width:"540",height:"960",cost:15,stepsPer:5,coinCost:15},
        {width:"720",height:"1280",cost:15,stepsPer:5,stepsLimit:150,coinCost:17},
        {width:"900",height:"1600",cost:30,stepsPer:10,stepsLimit:150,coinCost:25},
        {width:"1080",height:"1920",cost:45,stepsPer:15,stepsLimit:150,coinCost:40},

        {width:"1024",height:"1024",cost:30,stepsPer:7,stepsLimit:150,coinCost:20},
        {width:"2048",height:"2048",cost:120,stepsPer:28,stepsLimit:150,coinCost:80},
        {width:"896",height:"1152",cost:28,stepsPer:7,stepsLimit:150,coinCost:20},
        {width:"1792",height:"2304",cost:112,stepsPer:28,stepsLimit:150,coinCost:80},
        {width:"1152",height:"896",cost:28,stepsPer:7,stepsLimit:150,coinCost:20},
        {width:"2304",height:"1792",cost:112,stepsPer:28,stepsLimit:150,coinCost:80},
        {width:"640",height:"1280",cost:20,stepsPer:6,stepsLimit:150,coinCost:20},
        {width:"1280",height:"2560",cost:80,stepsPer:24,stepsLimit:150,coinCost:80},
        {width:"1280",height:"640",cost:20,stepsPer:6,stepsLimit:150,coinCost:20},
        {width:"2560",height:"1280",cost:80,stepsPer:24,stepsLimit:150,coinCost:80},
    ]
    const preset = [
        {"SD1.5":
            [
                {label:"縦長"},
                {width:"768",height:"1152",label:"",isFree:true,hires:true},
                {width:"1024",height:"1536",label:"",isFree:true,hires:true},
                {width:"512",height:"768",label:"低解像度検証向き",isFree:true,hires:false},
                {label:"正方形"},
                {width:"768",height:"768",label:"",isFree:true,hires:false},
                {width:"1152",height:"1152",label:"",isFree:true,hires:true},
                {width:"1536",height:"1536",label:"",isFree:true,hires:true},
                {width:"512",height:"512",label:"低解像度検証向き",isFree:true,hires:false},,
                {label:"縦長 1:2"},
                {width:"768",height:"1536",label:"",isFree:true,hires:true},
                {width:"384",height:"768",label:"低解像度検証向き",isFree:true,hires:false},
                {label:"横長"},
                {width:"1152",height:"768",label:"",isFree:true,hires:true},
                {width:"1536",height:"1024",label:"",isFree:true,hires:true},
                {width:"768",height:"512",label:"低解像度検証向き",isFree:true,hires:false},
                {label:"横長 2:1"},
                {width:"1536",height:"768",label:"",isFree:true,hires:true},
                {width:"768",height:"384",label:"低解像度検証向き",isFree:true,hires:false},
                {label:"横長 16:9"},
                {width:"960",height:"540",label:"",isFree:true,hires:true},
                {width:"1280",height:"720",label:"",isFree:true,hires:true},
                {width:"1600",height:"900",label:"",isFree:true,hires:true},
                {width:"1920",height:"1080",label:"",isFree:true,hires:true},
                {width:"480",height:"270",label:"低解像度検証向き",isFree:true,hires:false},
                {label:"縦長 9:16"},
                {width:"540",height:"960",label:"",isFree:true,hires:true},
                {width:"720",height:"1280",label:"",isFree:true,hires:true},
                {width:"900",height:"1600",label:"",isFree:true,hires:true},
                {width:"1080",height:"1920",label:"",isFree:true,hires:true},
                {width:"270",height:"480",label:"低解像度検証向き",isFree:true,hires:false},
            ]
        },
        {"SD3":[
            {label:"正方形"},
            {width:"1024",height:"1024",label:"",isFree:false,hires:false},

            {label:"縦長 2:3"},
            {width:"832",height:"1216",label:"",isFree:false,hires:false},

            {label:"縦長 9:16"},
            {width:"768",height:"1344",label:"",isFree:false,hires:false},

            {label:"縦長 9:21"},
            {width:"640",height:"1536",label:"",isFree:false,hires:false},

            {label:"横長 3:2"},
            {width:"1216",height:"832",label:"",isFree:false,hires:false},

            {label:"横長 16:9"},
            {width:"1344",height:"768",label:"",isFree:false,hires:false},

            {label:"横長 21:9"},
            {width:"1536",height:"640",label:"",isFree:false,hires:false},

        ]},
        {"SDXL":[
            {label:"縦長"},
            {width:"896",height:"1152",label:"",isFree:true,hires:false},
            {width:"1792",height:"2304",label:"高解像度",isFree:true,hires:true},
            {label:"正方形"},
            {width:"1024",height:"1024",label:"",isFree:true,hires:false},
            {width:"2048",height:"2048",label:"高解像度",isFree:true,hires:true},
            {label:"縦長 1:2"},
            {width:"640",height:"1280",label:"",isFree:true,hires:false},
            {width:"1280",height:"2560",label:"高解像度",isFree:true,hires:true},
            {label:"横長"},
            {width:"1152",height:"896",label:"",isFree:true,hires:false},
            {width:"2304",height:"1792",label:"高解像度",isFree:true,hires:true},
            {label:"横長 2:1"},
            {width:"1280",height:"640",label:"",isFree:true,hires:false},
            {width:"2560",height:"1280",label:"高解像度",isFree:true,hires:true},
        ]},
        {"DALL-E3":[
            {label:"正方形"},
            {width:"1024",height:"1024",label:"",isFree:false,hires:false},
        ]},
        {"NovelAI-Diffusion":[
            {label:"正方形"},
            {width:"1024",height:"1024",label:"",isFree:false,hires:false},
            {label:"縦長"},
            {width:"832",height:"1216",label:"",isFree:false,hires:false},
            {label:"横長長"},
            {width:"1216",height:"832",label:"",isFree:false,hires:false},
        ]}
    ]
    const freeList = [
        {width:"384",height:"768"},
        {width:"768",height:"384"},
        {width:"512",height:"512"},
        {width:"512",height:"768"},
        {width:"768",height:"512"},
        {width:"768",height:"768"},
        {width:"1024",height:"1024"},
        {width:"1152",height:"1152"},
        {width:"1536",height:"1536"},
        {width:"896",height:"1152"},
        {width:"768",height:"1152"},
        {width:"768",height:"1536"},
        {width:"1024",height:"1536"},
        {width:"1152",height:"768"},
        {width:"1152",height:"896"},
        {width:"1536",height:"768"},
        {width:"1536",height:"1024"},
        {width:"480",height:"270"},
        {width:"960",height:"540"},
        {width:"1280",height:"640"},
        {width:"1280",height:"720"},
        {width:"1600",height:"900"},
        {width:"1920",height:"1080"},
        {width:"270",height:"480"},
        {width:"540",height:"960"},
        {width:"640",height:"1280"},
        {width:"720",height:"1280"},
        {width:"900",height:"1600"},
        {width:"1080",height:"1920"},
    ]
    const testList = [
        {width:"384",height:"768"},
        {width:"768",height:"384"},
        {width:"512",height:"512"},
        {width:"512",height:"768"},
        {width:"768",height:"512"},
        {width:"480",height:"270"},
        {width:"270",height:"480"},
    ]
    const withoutHires = [
        {"width":"512","height":"512"},
        {"width":"512","height":"768"},
        {"width":"768","height":"512"},
        {"width":"384","height":"768"},
        {"width":"768","height":"384"},
        {"width":"480","height":"270"},
        {"width":"270","height":"480"}
    ];
    const SDXLHires = [
        {"width":"2048","height":"2048"},
        {"width":"1792","height":"2304"},
        {"width":"1280","height":"2560"},
        {"width":"2304","height":"1792"},
        {"width":"2560","height":"1280"}
    ];
    const [hires,setHires] = useState(false)
    function calcCost() {
        let resolution = sdResolution.split("x")
        let sampler = sdSampler
        let steps = document.getElementById("sd-steps")
        let jpCost = document.getElementById("sd-jp-prompt").value.length
        let width = 512
        let height = 512
        let hires = true
        if(resolution.length === 2){
            // txt2img
            if(generateTabKey === "txt2img" || img2ImgFile === undefined && inpaintFile === undefined){
                resolution = sdResolution.split("x")
                width = resolution[0]
                height = resolution[1]
                if(modelType === "SDXL"){
                    hires = SDXLHires.find(d => d.width === width && d.height === height) !== undefined
                } else {
                    hires = withoutHires.find(d => d.width === width && d.height === height) === undefined
                }
            } else if(img2ImgFile !== undefined || inpaintFile !== undefined){
                // img2img
                resolution = sdResolution.split("x")
                width = resolution[0]
                height = resolution[1]
                hires = false
            }
            //setSdResolution(width + "x" + height)
        } else {
            width = resolution[0]
            height = resolution[1]
            hires = true
        }
        setHires(hires)

        // コスト計算
        let cost = 0
        let coinCost = 0
        let per = 1
        for(let i = 0;i < costList.length;i++){
            if(width === costList[i].width && height === costList[i].height){
                cost = costList[i].cost
                per = costList[i].stepsPer
                coinCost = costList[i].coinCost
            }
        }
        if(steps.value > 10){
            cost += Math.floor(steps.value * per * 0.3) + parseInt(steps.value) - 10
        }
        if(steps.value > 30){
            coinCost += steps.value - 30
        }
        const longTimeSamplers = ["DPM++ SDE","DPM++ SDE Karras","DPM++ 2S a","DPM++ 2S a Karras","DPM2 Karras","DPM2 a Karras","Restart"];
        if(longTimeSamplers.find(d => d === sampler) !== undefined){
            cost += Math.floor(steps.value * per)
            coinCost *= 2
        }
        if(hires){
            cost *= 2.5
            cost = Math.floor(cost)
        }
        if(generateTabKey !== "txt2img" && (img2ImgFile !== undefined || inpaintFile !== undefined)){
            cost *= 1.2
            cost = Math.floor(cost)
        }
        let currentCost = cost
        let currentCoinCost = coinCost
        if(enterJpPrompt){
            currentCost = cost+jpCost
            currentCoinCost = coinCost+Math.floor(jpCost/5)
            setPointCost(cost+jpCost)
            setCoinCost(currentCoinCost)
        } else {
            currentCost = cost
            currentCoinCost = coinCost
            setPointCost(cost)
            setCoinCost(coinCost)
        }
        // slowモード
        if(paymentMethod === "point"){
            if(sdStyle === "slow"){
                for(let i = 0;i < freeList.length;i++){
                    if(width === freeList[i].width && height === freeList[i].height){
                        if(enterJpPrompt && ((loginInfo.plan !== "unlimited" && loginInfo.plan !== "plus") || isFullMode)){
                            currentCost = jpCost
                            setPointCost(jpCost)
                        } else {
                            currentCost = 0
                            setPointCost(0)
                        }
                        break;
                    }
                }
            } else {
                if((sdStyle !== "dall-e-3" && sdStyle !== "nai-diffusion-3" && !isFastMode) && loginInfo.plan == "certification" && before2SDTestCount < 100 && steps.value <= 30){
                    for(let i = 0;i < testList.length;i++){
                        if(width === testList[i].width && height === testList[i].height){
                            if(enterJpPrompt){
                                currentCost = jpCost
                                setPointCost(jpCost)
                            } else {
                                currentCost = 0
                                setPointCost(0)
                            }
                            break;
                        }
                    }
                }
            }
        }
        // freelistは無制限キャンペーン中のみ
        if(paymentMethod === "point"){
            if(freePeriodInfo.enabled === 1){
                for(let i = 0;i < freeList.length;i++){
                    if(width === freeList[i].width && height === freeList[i].height){
                        if(enterJpPrompt && ((loginInfo.plan !== "unlimited" && loginInfo.plan !== "plus") || isFastMode)){
                            currentCost = jpCost
                            setPointCost(jpCost)
                        } else {
                            currentCost = 0
                            setPointCost(0)
                        }
                        break;
                    }
                }
            }
        }
        // stepsが30以下かつ解像度が1536x1536、1920x1080、1080x1920以外の場合でプレミアムプランユーザーなら消費ポイント0
        if(!isFullMode){
            if(loginInfo.plan === "unlimited"){
                if(before24SDAllCount < 400 && steps.value <= 30 && !(width == 1536 && height == 1536)
                    && !(width == 1920 && height == 1080)
                    && !(width == 1080 && height == 1920)
                    && !(hires && modelType === "SDXL")){
                    currentCost = 0
                    setPointCost(0)
                }
            } else if(loginInfo.plan === "plus"){
                if(steps.value <= 50){
                    currentCost = 0
                    setPointCost(0)
                }
            }
        }
        if(sdStyle === "dall-e-3" || sdStyle === "nai-diffusion-3" || sdStyle === "sd3-large" || sdStyle === "sd3-large-turbo"){
            if(!isFullMode && (loginInfo.plan === "unlimited" || loginInfo.plan === "plus")){
                if(enterJpPrompt){
                    currentCost = jpCost
                    setPointCost(jpCost)
                } else {
                    currentCost = 0
                    setPointCost(0)
                }
            } else {
                let baseCost = 3000
                if(sdStyle === "sd3-large" || sdStyle === "sd3-large-turbo"){
                    baseCost = 6000
                }
                if(enterJpPrompt){
                    currentCost = baseCost+jpCost
                    setPointCost(baseCost+jpCost)
                } else {
                    currentCost = baseCost
                    setPointCost(baseCost)
                }
            }
            // コイン
            let baseCoinCost = 50
            if(sdStyle === "dall-e-3" || sdStyle === "sd3-large-turbo"){
                baseCoinCost = 40
            }
            if(enterJpPrompt){
                currentCoinCost = baseCoinCost+Math.floor(jpCost/5)
                setCoinCost(currentCoinCost)
            } else {
                currentCoinCost = baseCoinCost
                setCoinCost(baseCoinCost)
            }
        }
        if(sdImagesCount === "4"){
            currentCost *= 4
            currentCoinCost *= 4
            setPointCost(currentCost)
            setCoinCost(currentCoinCost)
        }
        if(modelType === "SDXL"){
            currentCost *= 2
            setPointCost(currentCost)
        }
        if(isScaleUpx2){
            currentCost *= 4
            currentCoinCost *= 4
            setPointCost(currentCost)
            setCoinCost(currentCoinCost)
        }
        if(useControlnet){
            currentCost *= 2
            setPointCost(currentCost)
        }
        if(modelIdentifiedName === "ourt_AI_Diffusion_XL_Anime_V1" && modelType === "SDXL" && steps.value <= 30){
            //currentCost = 0
            //setPointCost(currentCost)
        }
    }

    function calcUpscaleCost(){
        if(selectedImageWidth > 0 && selectedImageHeight > 0){
            let max = 10240 * 10240;
            let point = Math.ceil((Math.floor(selectedImageWidth * scaleBy) * Math.floor(selectedImageHeight * scaleBy)) / max * 100000);
            let coin = Math.ceil((Math.floor(selectedImageWidth * scaleBy) * Math.floor(selectedImageHeight * scaleBy)) / max * 500);
            //console.log(point,selectedImageWidth,selectedImageHeight,Math.floor(selectedImageWidth * scaleBy),Math.floor(selectedImageHeight * scaleBy))
            if(loginInfo.plan === "plus"){
                setUpscalePointCost(Math.ceil(point * 0.1))
            } else if(loginInfo.plan === "unlimited"){
                setUpscalePointCost(Math.ceil(point * 0.5))
            } else if(loginInfo.plan === "certification"){
                setUpscalePointCost(Math.ceil(point * 0.9))
            } else {
                setUpscalePointCost(point)
            }
            setUpscaleCoinCost(coin)
        } else {
            setUpscalePointCost(0)
        }
    }

    const [dragElm,setDragElm] = useState()
    // noと距離x,y
    const [len,setLen] = useState([-1,0,0])
    // 範囲内に存在する
    const [inRange,setInRange] = useState(false)
    // 選択中のno
    const [selectingNo,setSelectingNo] = useState(0)
    function dragStart(e,i){
        //console.log("dragStart",e)
        setDragElm("imgDrag"+i)
        //let img = document.querySelector("#imgDrag"+i)
        //console.log(img)
        if(e.type !== "touchstart"){
            let img = document.getElementById("dummy")
            e.dataTransfer.setDragImage(img,75, 75)
        }
        //e.dataTransfer.effectAllowed = "none"
    }

    function textareaSizing(labelElementId,elementId){
        let labelElement = document.querySelector(labelElementId)
        labelElement.style.lineHeight = "20px"
        let lineHeight = labelElement.style.lineHeight.replace(/[^0-9.]+/,'')
        let n = labelElement.value.match(/\n/g)
        if(n === null){
            n = 1
        } else {
            n = n.length + 1
        }
        if(n <= 5){
            n = 5
        }
        labelElement.style.height = lineHeight * n + 30 + "px"
        document.querySelector(elementId).style.height = lineHeight * n + 30 + "px"
    }

    // キャンバスのリサイズ
    const [canvasAreaHeight,setCanvasAreaHeight] = useState(window.innerHeight - 100)
    window.onresize = function () {
        setCanvasAreaHeight(window.innerHeight - 100)
    }
    const [showI2ICropper,setShowI2ICropper] = useState()
    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [showCropper,setShowCropper] = useState()
    const [cropTarget,setCropTarget] = useState()
    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
            let image = document.getElementById("load-image")
            let canvas = document.createElement("canvas")
            let ctx = canvas.getContext("2d")
            canvas.width = image.width
            canvas.height = image.height

            ctx.drawImage(image,0,0)

            const data = ctx.getImageData(croppedAreaPixels.x,croppedAreaPixels.y,croppedAreaPixels.width,croppedAreaPixels.height)

            canvas.width = croppedAreaPixels.width
            canvas.height = croppedAreaPixels.height

            ctx.putImageData(data,0,0)

            let thumb = canvas.toDataURL("image/png")

            setTempThumbnail(thumb)
      }, [])
    const [showQuestionnairePopup,setShowQuestionnairePopup] = useState(false)
    const [questionInfo,setQuestionInfo] = useState()
    document.onpaste = function(pasteEvent) {
        let item = pasteEvent.clipboardData.items[0];
     
        if (item.type.indexOf("image") === 0){
            let file = item.getAsFile();
            if(fileList.length === 0){
                imageSet([file])
            } else {
                imageAdd([file])
            }
        }
    }
    // シリーズ
    const [seriesList,setSeriesList] = useState([])
    const [series,setSeries] = useState("")

    function displayAIGenerateInfo(){
        dialog("AI生成機能の説明",<div>
            AI生成機能ではプロンプトという文字列を入力して、画像を生成することができます。<br />
            無料で利用することができますが、生成にはポイントを使用し、ポイントは、
            活動実績に伴い翌日の基準ポイントが判定され、保有ポイントがその基準以下の場合に基準まで回復します。<br />
            また、これ以外にも「いいね」やコメント、画像を投稿することでポイントが少し付与されます。<br /><br />
            <Link to={"/legal"}>スタンダードプラン、プレミアムプラン</Link>に加入している場合はSMS認証、ポイント不要でAI生成機能を利用できます。<br />

            不明点は<a href="https://discord.gg/vQNvaCXYvu">Discord</a>よりお問い合わせください。<br />
            <hr />
            ■ポイント回復基準<br />
            前日までの活動実績に伴い変動
            <br />
            ※条件は定期的に見直されます。<br />
            <hr />
            混雑時にはSMS認証が必須となる場合があります。SMS認証は「設定」→「セキュリティ」タグから行えます<br />
            <Link to={"/legal"}>サブスク</Link>に加入している場合はSMS認証不要でAI生成機能を利用できます。<br />
        </div>)
    }

    // AI生成機能の時間帯別利用件数
    const [userList,setUserList] = useState([])

    function createGraphData(r,title){
        const graphData = {
            labels: 
                // 軸ラベル
                // 各ラベルを配列にすることで軸ラベルが改行されて表示される
                r.map(d => [d.ymdh+"時"])
            ,
            datasets: [
                // 表示するデータセット
                {
                    data: r.map(d => d.count),
                    label: title
                },
            ],
        }
        return graphData
    }

    const [tagSelected,setTagSelected] = useState([])

    function upScaleHandler(){
        if(img2ImgFile === undefined){
            dialog("エラー","画像を選択してください。")
            return
        }
        if(selectedImageWidth === 0 || selectedImageHeight === 0){
            dialog("エラー","画像が読み込まれていません。")
            return
        }
        if(parseInt(selectedImageWidth*scaleBy) > 10240 || parseInt(selectedImageHeight*scaleBy) > 10240){
            dialog("エラー","拡大後の解像度が縦横ともに10,240px以内に収まるようにしてください。")
            return
        }
        clearAllInterval()
        statusCountUpdate(true)
        aiProccessingCall()

        upScale(img2ImgFile,scaleTargetStyle,scaleBy)

        document.querySelectorAll(".ai-proccesing-button").forEach(e => e.setAttribute("disabled",true))
    }
    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)
    const [paymentMethod, setPaymentMethod] = useState("point")
    function generateHandler(e,booking,random){
        let jpPrompt = document.getElementById("sd-jp-prompt").value
        let prompt = document.getElementById("sd-prompt").value
        let negativePrompt = document.getElementById("sd-negative-prompt").value
        let steps = document.getElementById("sd-steps").value
        let seed = document.getElementById("sd-seed").value
        let aiResolution = sdResolution
        let res = aiResolution.split("x")
        let width = res[0]
        let height = res[1].replace(/h/,"")
        let hires = false // hires判定はサーバーでやる
        if(tagSelected.length === 0 && prompt.trim().length === 0 && !styleSelected.find(d => d.prompt.length > 0) && enterJpPrompt && jpPrompt.length === 0){
            dialog("エラー","プロンプトを入力してください。")
            return
        }
        for(let i = 0;i < costList.length;i++){
            if(costList[i].width === width && costList[i].height === height){
                if(parseInt(steps) > costList[i].stepsLimit){
                    dialog("エラー",aiResolution + "の場合、stepsは最大" + costList[i].stepsLimit + "までにしてください。")
                    return
                }
            }
        }
        if(seed.length > 19){
            dialog("エラー","seedは最大19桁までにしてください。")
            return  
        }
        
        if(sdSampler === "DDIM" || sdSampler === "PLMS"){
            if(prompt.indexOf("AND") !== -1 || negativePrompt.indexOf("AND") !== -1){
                dialog("エラー","SamplerがDDIM/PLMSの場合はAND構文がサポートされていません。")
                return
            }
        }
        // プロンプトを記憶
        localStorage.removeItem("prompt")
        localStorage.removeItem("negativePrompt")
        localStorage.setItem("prompt",prompt)
        localStorage.setItem("negativePrompt",negativePrompt)
        prompt = prompt.replace(/{/g,"(")
        prompt = prompt.replace(/}/g,")")
        negativePrompt = negativePrompt.replace(/{/g,"(")
        negativePrompt = negativePrompt.replace(/}/g,")")

        prompt += (prompt.slice(-1) === "," ? "" : ",") + styleSelected.map(d => d.prompt.length > 0 ? (d.prompt.slice(-1) === "," ? d.prompt : d.prompt + ",") : "")
        negativePrompt += (negativePrompt.slice(-1) === "," ? "" : ",") + styleSelected.map(d => d.negative_prompt.length > 0 ? (d.negative_prompt.slice(-1) === "," ? d.negative_prompt : d.negative_prompt + ",") : "")

        if(qualityTags){
            if(sdStyle !== "ourt_AI_Diffusion_Anime_V4_niji_style_Beta" && sdStyle !== "ourt_AI_Diffusion_Anime_V6_niji-style_20240331"){
                if(sdStyle !== "nai-diffusion-3"){
                    prompt = "((masterpiece, best quality, extremely detailed, absurdres))," + prompt
                } else {
                    prompt = prompt + ",best quality, amazing quality, very aesthetic, absurdres"
                }
            }
            if(sdStyle === "nai-diffusion-3"){
                negativePrompt = "nsfw, lowres, {bad}, error, fewer, extra, missing, worst quality, jpeg artifacts, bad quality, watermark, unfinished, displeasing, chromatic aberration, signature, extra digits, artistic error, username, scan, [abstract]" + negativePrompt
            } else {
                if(modelType === "SDXL"){
                    negativePrompt = "(worst quality, low quality), nsfw, " + negativePrompt // blue_pencil-v9b
                } else {
                    negativePrompt = "(worst quality, low quality:1.4), nsfw, " + negativePrompt // blue_pencil-v9b
                }
            }
            //negativePrompt = "EasyNegative, extra fingers,fewer fingers," + negativePrompt
            //negativePrompt = "nsfw, lowres, bad anatomy, bad hands, text, error, missing fingers, extra digit, fewer digits, cropped, worst quality, low quality, normal quality, jpeg artifacts, signature, watermark, username,inaccurate limb," + negativePrompt
            //negativePrompt = "(KHFB, AuroraNegative),(worst quality, low quality:1.4),(monochrome:1.1)," + negativePrompt // 7th_test
        }
        if(tagSelected.length > 0){
            prompt = tagSelected.map(d => d.value).join(", ") + ", " + prompt
        }
        clearAllInterval()
        statusCountUpdate(true)
        aiProccessingCall()
        let styleP = styleSelected.map(d => d.prompt.length > 0 ? (d.prompt.slice(-1) === "," ? d.prompt : d.prompt + ",") : "")
        let styleNP = styleSelected.map(d => d.negative_prompt.length > 0 ? (d.negative_prompt.slice(-1) === "," ? d.negative_prompt : d.negative_prompt + ",") : "")
        if(random){
            prompt = ""
            negativePrompt = ""
            styleP = ""
            styleNP = ""
        }
        if(generateTabKey === "extra" && inpaintFile !== undefined && inpaintMask !== undefined){
            img2img(booking,random,sdImagesCount,sdStyle,isFullMode,isFastMode,isScaleUpx2,inpaintFile,inpaintMask,enterJpPrompt,jpPrompt,prompt,negativePrompt,styleP,styleNP,sdSampler,sdUpscaler,sdSteps,sdScale,sdDenoisingStrength,sdSeed,width,height)
        } else if(generateTabKey === "txt2img" && useControlnet){
            txt2imgControlnet(booking,random,sdImagesCount,sdStyle,isFullMode,isFastMode,isScaleUpx2,img2ImgFile,undefined,enterJpPrompt,jpPrompt,prompt,negativePrompt,styleP,styleNP,sdSampler,sdUpscaler,sdSteps,sdScale,sdDenoisingStrength,sdSeed,width,height)
        } else if(img2ImgFile === undefined){
            txt2img(booking,random,sdImagesCount,sdStyle,isFullMode,isFastMode,isScaleUpx2,enterJpPrompt,jpPrompt,prompt,negativePrompt,styleP,styleNP,sdSampler,sdUpscaler,sdSteps,sdScale,sdDenoisingStrength,sdSeed,width,height,hires)
        } else if(img2ImgFile !== undefined && generateTabKey === "txt2img" && !useControlnet){
            img2img(booking,random,sdImagesCount,sdStyle,isFullMode,isFastMode,isScaleUpx2,img2ImgFile,undefined,enterJpPrompt,jpPrompt,prompt,negativePrompt,styleP,styleNP,sdSampler,sdUpscaler,sdSteps,sdScale,sdDenoisingStrength,sdSeed,width,height)
        }
        document.querySelectorAll(".ai-proccesing-button").forEach(e => e.setAttribute("disabled",true))
    }
    function aiGenInitHandler(isCallHome){
        let aiGenCloseButton = document.querySelector("#aiGenCloseButton")
        if(loginInfo.result === false){
            dialog(t("common.info"),<RegistOrLogin dialog={dialog} />)
            return
        }
        if(loginInfo.sms_auth === 0 && !loginInfo.pre_auth){
            displayAIGenerateInfo()
        }
        // setUseAiGenerate(!useAiGenerate)
        //calcCost()
        if(useAiGenerate){
            // スタイルを取得する
            getStyleList().then(r => {
                if(r.result){
                    setStyleOptions(r.data)
                }
            })
            aiProccessingCall()
            setAIGenerateImagePage(1)
            aiGenCloseButton.innerText = t("upload.image.closeAIGenerationPanel")
            // プロンプトを復元する
            let jpPrompt = document.getElementById("sd-jp-prompt")
            let prompt = document.getElementById("sd-prompt")
            let negativePrompt = document.getElementById("sd-negative-prompt")
            let jpP = localStorage.getItem("jpPrompt")
            let p = localStorage.getItem("prompt")
            let np = localStorage.getItem("negativePrompt")
            if(jpPrompt.value.length === 0 && jpP !== null){
                jpPrompt.value = jpP
            }
            if(prompt.value.length === 0 && p !== null){
                prompt.value = p
            }
            if(!qualityTags && (np === null || np === "")){
                np = "(worst quality, bad quality, low quality:1.4),(extra fingers, deformed hands, polydactyl:1.5), (monochrome:1.1),"
            }
            if(negativePrompt.value.length === 0 && np !== null){
                negativePrompt.value = np
            }
            // プロンプトエリアの幅調整
            textareaSizing("#sd-jp-prompt",".sd-jp-prompt-textarea")
            textareaSizing("#sd-prompt",".sd-prompt-textarea")
            textareaSizing("#sd-negative-prompt",".sd-negative-prompt-textarea")
        } else {
            clearAllInterval()
            setAiProccessing(false)
            aiGenCloseButton.innerText = t("upload.image.AIGeneration")
        }
    }
    function inputCheck(){
        if(title.trim().length === 0){
            return false
        }
        if(styleOfPainting.length === 0 ){
            return false
        }
        if(ageLimit === ""){
            return false
        }
        // 全年齢の場合、性的表現について必須
        if(ageLimit === "1" || ageLimit === "2"){
            if(ageLimit === "1" && sexualExpression === ""){
                return false
            }
        } else {
            if(sexualExpression !== ""){
                return false
            }
        }
        return true
    }
    useEffect(() => {
        setUploadReady(inputCheck())
    },[title,styleOfPainting,ageLimit,sexualExpression])

    function uploadHandler(e){
        let title = document.getElementById("title")
        let description = document.getElementById("description")
        let deletePassword = document.getElementById("delete-password")
        let batch = document.getElementById("batch").checked
        if(!batch && title.value.trim().length === 0 ){
            dialog("エラー","タイトルを入力して下さい。")
            return false
        }
        if(styleOfPainting.length === 0 ){
            dialog("エラー","画風を選択してください。")
            return false
        }
        /*if(description.value.trim().length === 0){
            dialog("エラー","概要を入力して下さい。")
            return false
        }*/
        if(bookingDate !== "" && bookingTime === ""){
            dialog("確認","予約投稿を行う場合は時分も入力してください。")
            return false
        }
        if(bookingDate === "" && bookingTime !== ""){
            dialog("確認","予約投稿を行う場合は年月日も入力してください。")
            return false
        }
        if(ageLimit === ""){
            dialog("エラー","年齢制限を指定して下さい。")
            return false
        }
        // 全年齢の場合、性的表現について必須
        if(ageLimit === "1" || ageLimit === "2"){
            if(ageLimit === "1" && sexualExpression === ""){
                dialog("エラー","PG12区分ありなしを指定して下さい。")
                return false
            }
        } else {
            if(sexualExpression !== ""){
                dialog("エラー","性的表現の指定は不要です。")
                return false
            }
        }
        let aiModel = document.getElementById("ai-model")
        let prompt = document.getElementById("prompt")
        let negativePrompt = document.getElementById("negative-prompt")
        let request = document.getElementById("request")
        for(let i = 0;i < fileList.length;i++){
            if(fileList[i].software === "" || fileList[i].software === "no-select"){
                //dialog("エラー",<Container>全ての画像に使用したモデルを入力してください。</Container>)
                //return false
            }
        }
        if(prompt.value.trim().length > 50000){
            dialog("エラー","生成テキスト、プロンプトの上限は50,000文字です。")
            return false
        }
        if(negativePrompt.value.trim().length > 50000){
            dialog("エラー","ネガティブプロンプトの上限は50,000文字です。")
            return false
        }
        if(request.value.trim().length > 50000){
            dialog("エラー","機能追加要望等の上限は50,000文字です。")
            return false
        }
        if(loginInfo.length === 0){
            if(deletePassword.value.trim().length === 0 && loginInfo.length === 0){
                dialog("エラー","削除パスワードを入力して下さい。")
                return false
            }
        }
        // ファイルサイズチェック
        let fileSize = 0
        for(let i = 0;i < fileList.length;i++){
            fileSize += fileList[i].file.size
        }
        // 104857600 100MB
        // 262144000 200MB
        // 107374182400 100GB
        if(fileSize > 31457280000){
            dialog("エラー","ファイルサイズの合計は30GBです。")
            return
        }
        if(fileList.length === 0){
            dialog("エラー","ファイルを選択して下さい。")
            return false
        }
        // ファイル数チェック
        if(fileList.length > 300){
            dialog("エラー","一度にアップロードできるのは300ファイルまでです。")
            return false
        }
        if(insideThumbnail === undefined){
            dialog("エラー","サムネイルを設定してください。")
            return false
        }
        /*
        if(outsideThumbnail === undefined){
            dialog("エラー","外部サイト向けサムネイルを設定してください。")
            return false
        }*/
        if(questionInfo !== undefined){
            if((questionInfo.deadlineDate.length === 0 && questionInfo.deadlineTime.length > 0)
                || (questionInfo.deadlineDate.length > 0 && questionInfo.deadlineTime.length === 0)){
                dialog(t("common.error"),"投票を作成する場合は日付と時間を両方指定してください。")
                return false
            }
        }
        //isLoggin().then(r=>{
        //    if(r){
                uploadSelect(fileList)
        //    } else {
        //        dialog("エラー","投稿するにはログインしてください。")
                // トップへ戻る
                //document.getElementById("logo").click();
        //    }
        //})
    }
    const [showGeneratedCount,setShowGeneratedCount] = useState(false)
    const [showTaiki,setShowTaiki] = useState(false)
    const [showLora,setShowLora] = useState(false)
    const [showEmbeddings,setShowEmbeddings] = useState(false)
    const getDefaultStyleWeight = useCallback((name) => {
        let prompt = document.querySelector("#sd-prompt")
        let match = prompt.value.match("<lora:"+name+":([0-9.-]+)>")
        let weight = 0
        if(match !== null && match.length > 1){
            weight = match[1]
        } else {
            let range = document.querySelector("#"+name+"-range")
            if(range){
                weight = range.value
            }
        }
        prompt.value = prompt.value.replace("><",">,<")
        return weight
    })
    let loraList = ["ear-tarenagamimi_01",
    "ear-tarenagamimi_02",
    "emo-smile_01",
    "eye-allsclera",
    "eye-close_c",
    "eye-grgr_01",
    "eye-grgr_02",
    "eye-hanme_01",
    "eye-hanme_02",
    "eye-hanme_03",
    "eye-hanme_04",
    "eye-hanme_c_01",
    "eye-hanme_c_02",
    "eye-iris_width",
    "eye-kuma_01",
    "eye-kuma_02",
    "eye-lookleft_01",
    "eye-lookleft_02",
    "eye-lookright_01",
    "eye-lookright_02",
    "eye-lookup",
    "eye-nolight",
    "eye-nolight_02",
    "eye-nolight_03",
    "eye-pos_h",
    "eye-pos_v",
    "eye-shihaku",
    "eye-shiitake",
    "eye-turime",
    "hair-bangsstyle_01-16",
    "hair-bangsstyle_02-16",
    "hair-bangsstyle_03-16",
    "hair-bangsstyle_04-16",
    "hair-bangsstyle_05-16",
    "hair-bangsstyle_06-16",
    "hair-bangsstyle_07-16",
    "hair-bangsstyle_08-16",
    "line_softline",
    "mouth-open_h_01",
    "mouth-open_h_02",
    "nose-dot",
    "nuri-hadanuri_01",
    "nuri-hadanuri_02",
    "nuri-sanDka_01",
    "nuri-sanDka_02",
    "nuri-yawanuri",
    "style-dorodoro_01",
    "style-dorodoro_02",
    "dtl-illust2real",
    "body-necklength",
    "DynLighting",
    "BlurConditioner_A1823"]

    function moveTo(name){
        let title = document.querySelector(name)
        let rect = title.getBoundingClientRect()
        window.scrollTo({top:window.scrollY+rect.top-100,left:0,behavior:"instant"})
    }
    const [uploadReady,setUploadReady] = useState(false)

    // モザイク強度最小値
    const [minMosaicStrength,setMinMosaicStrength] = useState(0)

    const [showModels,setShowModels] = useState(false)
    const [showModelRecommendedSettings,setShowModelRecommendedSettings] = useState(false)
    const [recommendPrompt,setRecommendPrompt] = useState("")

    const [selectedGenerateImageList,setSelectedGenerateImageList] = useState([])
    const [addFiles,setAddFiles] = useState(false)

    async function addFile(){

    }
    useEffect(() => {
        if(addFiles){
           //addFile()
        }
    },[addFiles])

    const [tipsImageNo,setTipsImageNo] = useState(1)
    const [isAd,setIsAd] = useState()
    const [adTitle,setAdTitle] = useState()
    const [adText,setAdText] = useState()
    const [adElement,setAdElement] = useState()

    const tipsList = [{"isAd":false,"title":"ドット絵の様な画像を生成するには","text":"プロンプトに「pixel art」を入力","element":""},
        {"isAd":false,"title":"水彩画の様な画像を生成するには","text":"プロンプトに「aquarelle」を入力","element":""},
        {"isAd":false,"title":"アニメのスクリーンショットの様な画像を生成するには","text":"「(anime:1.4)」を入力","element":<Image src='/img/tips/anime.webp' width={"100%"} />},
        {"isAd":true,"title":"身分証提出による認証マーク","text":<>公認クリエイターになって口座設定を行った場合、身分証提出による認証マークが付与されます。<Icon.ShieldFillCheck style={{display:"inline",color:"#E2B719",marginLeft:"10px"}} /></>,"element":""},
        {"isAd":false,"title":"画質を上げるには","text":"解像度を上げてみよう。","element":<Image src='/img/tips/scale.webp' width={"100%"} />},
    ]

    useEffect(() =>{
        if(aiProccessing){
            let lists = [tipsList]
            if(loginInfo.plan === ""){
                lists.push(adList.concat(adInfo.map(d => {
                    return {"isAd":true,"title":"","text":"","element":<><Link to={d.url} target='_blank'><Image src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/ad/"+d.user_id+"/"+d.img_id+".webp"} /></Link></>}
                })))
            }
            let list = arrayShuffle(lists)[0]

            const ad = arrayShuffle(list)[0]
            setTipsImageNo(Math.floor(Math.random() * 4 + 1))
            setIsAd(ad.isAd)
            setAdTitle(ad.title)
            setAdText(ad.text)
            setAdElement(ad.element)
        }
    },[aiProccessing])

    function isFastSampler(name,fastModeVer){
        if(fastModeVer === 4){
            return name.startsWith("Euler A Turbo") || name.startsWith("DPM++ 2M Turbo") || name.startsWith("DPM++ 2M SDE Turbo")
        } else {
            return name.startsWith("Euler a") || name.startsWith("DPM++ 2S a Karras")
        }
    }

    useEffect(() => {
        if(img2ImgFile === undefined){
            setSelectedImageWidth(0)
            setSelectedImageHeight(0)
        }
    },[img2ImgFile])

    const months = [];
    for (let month = 1; month <= 12; month++) {
        months.push(month);
    }
    const days = [];
    for (let day = 1; day <= 31; day++) {
        days.push(day);
    }

    return (
    <>
    <Form.Control type="file" encType="multipart/form-data" accept="*.*" className='d-none' id="img2img-file" onChange={(e) => {
        ImageUtil.load(undefined,e.currentTarget.files[0],0,(data1,data2,base64) => {
            Array.from(document.getElementsByClassName("img2img-thumb")).forEach(e => e.src = data1)
            setImg2ImgFile(base64)
            if(generateTabKey !== "extra"){
                setShowI2ICropper(true)
            }
            let img = document.createElement("img")
            img.onload = () => {
                setSelectedImageWidth(img.naturalWidth)
                setSelectedImageHeight(img.naturalHeight)
                console.log("読込後",img.naturalWidth,img.naturalHeight)
                img.remove()
            }
            img.src = base64
        })
        e.currentTarget.value = ""
    }} />
    <CropButton show={showI2ICropper} setShowCropper={setShowI2ICropper} aspect={sdWidth / sdHeight} onChange={(img) => {
        setImg2ImgFile(img)
        let elm = document.createElement("img")
        elm.onload = () => {
            setSelectedImageWidth(elm.naturalWidth)
            setSelectedImageHeight(elm.naturalHeight)
            console.log("クロップ後",elm.naturalWidth,elm.naturalHeight)
            elm.remove()
        }
        elm.src = img
        Array.from(document.getElementsByClassName("img2img-thumb")).forEach(e => e.src = img)
    }}
    onCancel={() => {
        document.getElementById("img2img-file").value = ""
        Array.from(document.getElementsByClassName("img2img-thumb")).forEach(e => e.src = "")
        setImg2ImgFile()
    }}
    src={img2ImgFile} />
    <div style={{display:editImageTargetNo !== -1 ? "block" : "none",position:"fixed",top:0,width:"100%",height:"100%",background:"#000000",zIndex:4,opacity:"0.9"}}>
    </div>
    <div id="paint-tools" style={{display:editImageTargetNo !== -1 ? "block" : "none",position:"fixed",top:0,color:"#FFFFFF",margin:"0 auto",zIndex:4,width:"100%"}} className="text-center">
        <div style={{width:"100%"}} className="d-flex justify-content-center">
            <p style={{display:"block"}}>モザイクのスタイル：</p>
            <Form.Select id="mosaic-size" className="mb-1" style={{display:"block",width:"100px"}}
                onChange={(e) => {
                    setMosaicStyle(e.currentTarget.value)
                    setMosaicImage()
                }}>
                <option value="dot">ドット</option>
                <option value="blur">ぼかし</option>
            </Form.Select>
            <p style={{display:"block"}}>モザイクの大きさ：</p>
            <Form.Select id="mosaic-size" className="mb-1" style={{display:"block",width:"100px"}}
                onChange={(e) => {
                    setMosaicSize(e.currentTarget.value)
                }} defaultValue={30}>
                {[...Array(30)].map((v,i) => {
                    if((i+1)*2 < 29) return ""
                    return <option value={(i+1)*2} key={i}>{(i+1)*2}px</option>
                })}
            </Form.Select>
            <p style={{display:"block"}}>モザイク強度：</p>
            <Form.Control type="number" id="mosaic-strength" min={minMosaicStrength} className="mb-1" style={{display:"block",width:"100px"}}
                onChange={(e) => {
                    setMosaicStrength(e.currentTarget.value)
                    setMosaicImage()
                }} defaultValue={20}>
            </Form.Control>
        </div>
        <Button variant={editLabel === "mosaic" ? 'light' : "primary"} onClick={() => {
            setDrawFlag(1)
            setEditLabel("mosaic")
        }}><Icon.BrushFill /></Button>
        <Button variant={editLabel === "eraser" ? 'light' : "primary"} style={{marginLeft:"3px"}} onClick={() => {
            setDrawFlag(2)
            setEditLabel("eraser")
        }}><Icon.EraserFill /></Button>
        <Button variant='primary' style={{marginLeft:"3px"}} onClick={() => {
            mosaicCanvas()
        }}>全体をモザイク</Button>
        <Button variant='success' style={{marginLeft:"3px"}} onClick={() => {
            saveEdit()
        }}>OK</Button>
        <Button variant='danger' style={{marginLeft:"3px"}} onClick={() => {
            resetCanvas()
        }}>Reset</Button>
        <Button variant='danger' style={{marginLeft:"3px"}} onClick={() => {
            closeEdit()
        }}>Close</Button>
        <br />
        <canvas id="tempCanvas" style={{display:"none"}} />
        <div id="canvas-area" className="m-0 p-0" data-selectdrawflag={1} data-mosaicsize={30} data-mosaicstrength={20} data-imageeditflag={0} data-mosaicstyle={"dot"} 
            style={{width:"auto",height:canvasAreaHeight,overflow:"auto"}}
        />
        <canvas id="original-image" style={{display:"none"}} />
        <canvas id="mosaic-image" style={{display:"none"}} />
    </div>
    <div className="wrapper">
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Header />
        <Category />
        <div style={{margin:"0 auto",width:"360px",boxSizing:"border-box",position:"fixed",zIndex:"1",top:(window.innerHeight - 500) / 2,left:(window.innerWidth - 360) / 2,display:postedGroupId !== "" ? "block" : "none"}}>
            <Alert style={{position:"absolute"}}>
                <CloseButton style={{position:"absolute",right:"20px"}} onClick={() => {
                    setPostedGroupId("")
                    setURL("")
                    setImgURL("")
                }}/>
                <p>投稿完了しました。<br />
                   SNSで共有してたくさんの人に見てもらいましょう！<br />
                   ※新着には10分程で反映されます。<br />
                   </p>
                <p><a href={url} target="_blank" rel="noreferrer" style={{textDecoration:"none",padding:"8px 14px",borderRadius:"20px",backgroundColor:"#000000",color:"#FFFFFF",border:"1px solid #1D9BF0"}}>𝕏 Post</a></p>
                <div style={{width:"360px",height:"360px"}}>
                    <Link to={"/character/"+postedGroupId}><Image src={imgUrl} style={{objectFit:"cover",width:"100%",height:"100%",borderRadius:"20px"}} /></Link>
                </div>
            </Alert>
        </div>
        <Container style={{display:postedGroupId !== "" ? "none" : "block"}}>
            <Tabs defaultActiveKey="character" className="mt-3" 
            onSelect={(s) => {if(s !== "audio") navigate("/upload/"+s)}}>
                <Tab eventKey="model" title={<><Icon.Magic /> {t("common.model")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/model")}></Tab>
                <Tab eventKey="character" title={<><Icon.Person /> {t("upload.character.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/character")}></Tab>
                <Tab eventKey="image" title={<><Icon.Image /> {t("upload.image.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/image")}></Tab>
                <Tab eventKey="video" title={<><Icon.FileText /> {t("upload.video.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/video")}></Tab>
                <Tab eventKey="text" title={<><Icon.FileText /> {t("upload.text.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/text")}></Tab>
                <Tab eventKey="audio" title={<><Icon.VolumeUp /> {t("upload.audio.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/audio")}>
                    準備中・・・
                </Tab>
                <Tab eventKey="event" title={<><Icon.Shop /> {t("upload.event.title")}</>} style={{position:"relative",display:postedGroupId === "" ? "block" : "none"}} onClick={() => navigate("/upload/event")}></Tab>
            </Tabs>
            {false && odai ? <Link to={"/odai"} className='d-none d-md-block'><Alert variant='warning'>今日のお題「{odai}」</Alert></Link> : ""}
                    <pre style={{backgroundColor:"#555555",color:"#FFFFFF",padding:"10px",borderRadius:"5px",display:messageShow}}>{message}</pre>
                    <Container className='mb-3'>
                        自分自身のオリジナルキャラクターを登録しよう。手描き、AIどちらでも登録できます。<br /><span style={{color:"#555555",fontSize:"14px"}}>※二次創作キャラは登録できません。</span>
                    </Container>
                    <h3>①{t("upload.image.images")}</h3>
                    <div style={{display:"block"}}>
                        <InputGroup className="mb-3" style={{maxWidth:"450px"}}>
                            <InputGroup.Checkbox style={{cursor:"pointer"}} defaultChecked={notReadPromptInfo} id="read-prompt-info" onChange={(e) => {
                                setNotReadPromptInfo(e.currentTarget.checked)
                            }} />
                            <Form.Control type="text" value={t("upload.image.fileSelectReadPrompt")} readOnly />
                        </InputGroup>
                    </div>
                    <Container className="d-block mb-3" style={{border:"3px solid #000000",borderRadius:"5px",minHeight:"100px",overflow:"auto",cursor:"pointer"}} id="upload-area"
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={(e) => {
                            e.preventDefault()
                            const tags = ExifReader.load(e.dataTransfer.files[0],{includeUnknown: true})
                            tags.then(r => {
                                console.log(r)
                            })
                            if(fileList.length === 0){
                                imageSet(e.dataTransfer.files)
                            } else {
                                if(dragElm === undefined){
                                    imageAdd(e.dataTransfer.files)
                                }
                            }
                        }}
                        onDragEnd={() => setDragElm()}
                        onClick={(e) => {
                            e.stopPropagation()
                            if(fileList.length === 0){
                                document.getElementById("file").click()
                            } else {
                                document.getElementById("file_add").click()
                            }
                        }}
                        onDrag={(e) => {
                            if(dragElm){
                                let img = document.getElementById(dragElm)
                                let no = img.dataset.no
                                let imgClient = img.getBoundingClientRect()
                                let uploadClient = document.querySelector("#upload-area").getBoundingClientRect()
                                let bodyClient = document.querySelector("body").getBoundingClientRect()
                                // console.log(e.pageY,client.top,client.y,window.scrollY)
                                let x = e.pageX - window.scrollX
                                let y = e.pageY - window.scrollY
                                img.style.position = "fixed"
                                img.style.top = y - 75 +"px"
                                img.style.left = x - 75 + "px"
                                img.style.zIndex = "201"
                                //console.log(x,y,no )
                                let range = false
                                let l = len
                                let moreThan1 = false
                                fileList.forEach((elm,i) => {
                                    if(no === String(i)) return
                                    let targetImg = document.getElementById("imgDrag"+i)
                                    let client = targetImg.getBoundingClientRect()
                                    // 中心からの距離が一番近いもの？
                                    let targetX = client.x + (client.width / 2)
                                    let targetY = client.y + (client.height / 2)
                                    let lenX = Math.abs(x - targetX)
                                    let lenY = Math.abs(y - targetY)
                                    if(((l[1] >= lenX && l[2] >= lenY) || (lenX < 75 && lenY < 75)) || l[0] === -1){
                                        l = [i,lenX,lenY]
                                        //console.log(i,x,y,targetX,targetY,"近い要素："+l[0],lenX,lenY)
                                        moreThan1 = true
                                    }
                                })
                                setLen(l)
                                range = (l[1] < 75 && l[2] < 75) && l[0] !== -1 && moreThan1
                                setInRange(range)
                                setSelectingNo(no)
                                // console.log(x,y,img2.getBoundingClientRect())
                            }
                        }}
                        onDragEnter={(e) => {
                            //console.log("dragEnter",e)
                        }}
                        >
                        {fileList.map((imgFile,i) => {
                            if(imgFile.imageData !== undefined){
                                document.getElementById("img" + i).src = imgFile.imageData
                            } else {
                                ImageUtil.load(fileList,imgFile.file,i,(data,data2,data3)=>{
                                    if(data === false){
                                        imgFile.error = true
                                        setMessageShow("block")
                                        setMessage(message+"「"+imgFile.file.name+"」が読み込めませんでした。\r\n")
                                        // エラーなら削除
                                        setFileList(fileList.map(f=>f).filter((imgFile,idx)=>!imgFile.error))
                                    } else {
                                        let elm = document.getElementById("img"+i)
                                        if(elm) elm.src = data
                                        imgFile.imageData = data
                                        imgFile.imageDataMiddle = data2
                                        imgFile.imageDataOriginal = data3
                                        imgFile.imageDataEdited = data3
                                        if(i === editImageNo) document.getElementById("select-img").src = data
                                        //if(i === editImageNo) document.getElementById("select-img-ai").src = data2
                                        if(i === editImageNo) setMetaDataField(fileList[editImageNo],true)
                                        // サムネイル調整用の初期画像
                                        if(i === editImageNo) {
                                            document.getElementById("load-image").src = fileList[editImageNo].imageDataEdited
                                        }
                                    }
                                })
                            }
                            return (
                                <div className="m-1" style={{float:"left",width:"150px",height:"150px",position:"relative"}} key={i} data-no={i} id={"imgDiv"+i}
                                onTouchStart={(e) => dragStart(e,i)}
                                onDragStart={(e) => dragStart(e,i)}
                                onDragEnd={(e) => {
                                    e.preventDefault()
                                    //console.log("dragEnd",len)
                                    let img = document.getElementById(dragElm)
                                    img.style.top = ""
                                    img.style.left = ""
                                    img.style.zIndex = "1"
                                    img.style.position = "relative"
                                    setLen([-1,0,0])
                                    let no = parseInt(e.currentTarget.dataset.no)

                                    if(inRange){
                                        // 挿入 no(選択中の要素)とlen[0]                                        
                                        let list = fileList.concat()
                                        if(no < len[0]){
                                            if(len[0] - no === 1){
                                                let tmp = list[no]
                                                list[no] = list[len[0]]
                                                list[len[0]] = tmp
                                                setFileList(list)
                                                setEditImageNo(len[0])
                                            } else {
                                                list.splice(len[0]+1,0,list[no])
                                                setFileList(list.filter((d,i) => i !== no))
                                                setEditImageNo(len[0])
                                            }
                                        } else if(no > len[0]){
                                            list.splice(len[0],0,list[no])
                                            setFileList(list.filter((d,i) => i !== no+1))
                                            setEditImageNo(len[0])
                                        }
                                        setSelectingNo(no)
                                        setDragElm("imgDrag"+len[0])
                                    } else {
                                        setDragElm()
                                        setSelectingNo(no)
                                    }
                                }}
                                onDrag={(e) => {
                                    //console.log("onDrag")
                                }}
                                >
                                    <div style={{width:"150px",height:"150px",position:"relative",backgroundColor:"#FFFFFF",
                                    marginLeft:inRange && len[0] === i ? (len[0] > selectingNo ? "-50px" : "50px") : "0px"}} id={"imgDrag"+i} data-no={i}>
                                        <Image className="upload-thumb" alt={imgFile.file.name} id={"img"+i} style={{objectFit:"contain",position:"absolute",width:"100%",height:"100%",cursor:"grab",
                                            border:editImageNo === i ? "6px solid orange" : "none"}} onClick={(e) => {
                                            e.stopPropagation()
                                            setEditImageNo(i)
                                        }}
                                        onDrag={(e) => {
                                            e.preventDefault()
                                        }}
                                        onDragEnd={(e) => {
                                            e.preventDefault()
                                        }}
                                        />
                                        <Icon.PencilFill style={{fontSize:"24px",position:"absolute",right:"40px",top:"10px",borderRadius:"20px",backgroundColor:"#FFFFFF",
                                            color:imgFile.useMosaic === "1" ? "#FF0000" : "blue"}} onClick={(e) => {
                                            e.stopPropagation()
                                            // 編集対象として設定
                                            setEditImageTargetNo(i)
                                        }} title="モザイクをかける" />
                                        <CloseButton style={{position:"absolute",right:"10px",top:"10px",borderRadius:"20px",backgroundColor:"#FFFFFF"}} onClick={(e) => {
                                            e.stopPropagation()
                                            // リストから画像削除
                                            setFileList(fileList.map(f=>f).filter((file,idx)=>i!==idx))
                                            //if(fileList.length === 1) deleteFormValue() 削除されるのが面倒らしい
                                            if(editImageNo !== 0 && editImageNo >= i) setEditImageNo(editImageNo - 1)
                                        }} title="閉じる" />
                                        <Container style={{position:"absolute",bottom:"0",width:"100%",backgroundColor:"rgba(0,0,0,0.5)",color:"#FFFFFF",overflow:"hidden",whiteSpace:"nowrap"}}>{imgFile.file.name}</Container>
                                    </div>
                                </div>
                            )
                        })}
                        <Image id="dummy" src="/img/dot.png" style={{display:fileList.length > 0 ? "inline" : "none"}} />
                        {fileList.length === 0 ? (
                        <Container className="text-center p-3" style={{clear:"both",fontSize:"18px"}}>
                            <Icon.Upload style={{fontSize:"64px"}}/><br />
                            {t("upload.image.fileDragAndDrop")}<br />
                            {t("upload.image.paste")}<br />
                            <MuiButton variant='outlined' className='m-1'>{t("upload.image.selectFile")}</MuiButton>
                            <MuiButton variant='outlined'    className='m-1'
                                style={{display:loginInfo.result !== undefined && loginInfo.result ? "inline" : "none",marginRight:"10px"}}
                                onClick={(e) => {
                                    e.stopPropagation()
                                    if(displayAIGeneratedPanel){
                                        setAIGenerateImageList([])
                                        setAIGenerateImagePage(-1)
                                        setDisplayAIGeneratedPanel(false)
                                    } else {
                                        setAIGenerateImagePage(1)
                                        setDisplayAIGeneratedPanel(true)
                                    }
                            }}>{t("upload.image.selectByGeneratedHistory")}</MuiButton>
                        </Container>
                        ) : (
                        <div className="m-1 file-add" style={{float:"left",borderRadius:"10px",width:"150px",height:"150px",marginTop:"10px",position:"relative",border:"3px solid #555555"}}>
                            <Icon.PlusLg style={{fontSize:"48px",marginTop:"45px"}} className="w-100" />
                        </div>
                        )}
                    </Container>
                    <p style={{display:fileList.length > 0 ? "inline" : "none"}}><Button variant='outline-primary'
                    onClick={(e) => {
                        e.stopPropagation()
                        // 編集対象として設定
                        setEditImageTargetNo(editImageNo)
                    }} title="モザイクをかける"
                    ><Icon.PencilFill style={{color:"#0000FF"}} /> モザイク編集</Button>
                    <Button className='m-1' variant='outline-secondary'
                        style={{display:loginInfo.result !== undefined && loginInfo.result ? "inline" : "none",marginRight:"10px"}}
                        onClick={(e) => {
                            e.stopPropagation()
                            if(displayAIGeneratedPanel){
                                setAIGenerateImageList([])
                                setAIGenerateImagePage(-1)
                                setDisplayAIGeneratedPanel(false)
                            } else {
                                setAIGenerateImagePage(1)
                                setDisplayAIGeneratedPanel(true)
                            }
                    }}>{t("upload.image.selectByGeneratedHistory")}</Button>
                    </p>
                    {displayAIGeneratedPanel ? (
                        <DynamicDialog autoSizing={true} switch={setDisplayAIGeneratedPanel} content={
                            <Container>
                                <Container className='text-center'>
                                    <Button className='m-3' onClick={() => {
                                        setDisplayAIGeneratedPanel(false)
                                        let images = []
                                        selectedGenerateImageList.forEach(d => {
                                            getAIGeneraleImageFile(d.proc_id).then(r => {
                                                if(r.result){
                                                    images = images.concat(r.data.img.map(img => {
                                                        return base64ToFile(img.replace(/^.*,/, ''),d.proc_id + ".png","image/png")
                                                    }))
                                                    return images
                                                } else {
                                                    return []
                                                }
                                            }).then(r => {
                                                if(selectedGenerateImageList.map(d => d.count).reduce((prev,current) => prev += current) === r.length){
                                                    imageAdd(images,true)
                                                    setSelectedGenerateImageList([])
                                                } else {

                                                }
                                            })
                                        })
                                    }}>OK</Button>
                                    <Button className='m-3' onClick={() => {
                                        setDisplayAIGeneratedPanel(false)
                                        setSelectedGenerateImageList([])
                                    }}>Cancel</Button>
                                    <Button className='m-3' onClick={() => {
                                        setSelectedGenerateImageList([])
                                    }}>解除</Button>
                                </Container>
                                <Container style={{border:"3px lightblue solid",borderRadius:"5px",overflow:"auto"}} className="d-flex flex-wrap justify-content-between mt-3">
                                    <div className='p-3'>
                                        サイズ<br />
                                        <Slider style={{width:"100px"}} onChange={(e) => {
                                            setGenerateImageListCols(e.target.value)
                                        }} value={generateImageListCols} min={1} max={5} aria-label="Default" />
                                    </div>
                                    <ImageList
                                        sx={{ width: "100%", height: generatedImageListHeight }}
                                        variant="quilted"
                                        cols={generateImageListCols}
                                        gap={8}
                                        id={"generated-image-list"}
                                    >
                                    {aiGenerateImageList.map((data,i) => (
                                        <ImageListItem key={i} style={{position:"relative"}}>
                                            <Container style={{position:"absolute",width:"100%",height:"100%",zIndex:1,cursor:"pointer"}}
                                                onClick={(e) => {
                                                    setSelectedGenerateImageList(selectedGenerateImageList.concat(data))
                                                    if(selectedGenerateImageList.find(d => d.proc_id === data.proc_id) !== undefined){
                                                        setSelectedGenerateImageList(selectedGenerateImageList.filter(d => d.proc_id !== data.proc_id))
                                                    } else {
                                                        //setSelectedGenerateImageList([].concat(data.proc_id))
                                                    }
                                                }}
                                                >
                                                    <Container>
                                                        <input id={'generated'+data.proc_id} type="checkbox" className="delete-check"  onClick={(e) => {
                                                           
                                                        }}
                                                        style={{position:"absolute",zIndex:"1",width:"32px",height:"32px",top:"10px",right:"10px",cursor:"pointer"}}
                                                        defaultChecked={0} data-proc_id={data.proc_id}
                                                        checked={selectedGenerateImageList.find(d => d.proc_id === data.proc_id) !== undefined} />
                                                        <Badge bg="secondary" style={{position:"absolute",zIndex:"1",bottom:"10px",right:"10px"}}>
                                                            {data.count > 1 ? <><Icon.Images style={{fontSize:"24px",color:"#EEEEEE"}} />&nbsp;</> : ""}
                                                            <Icon.InfoCircle style={{fontSize:"24px",color:"#EEEEEE",cursor:"pointer"}} onClick={(e) => {
                                                                setShowGeneratedInfo(true)
                                                                setGeneratedInfo(data)
                                                            }} />
                                                        </Badge>
                                                    </Container>
                                                </Container>
                                            <img
                                                src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+'/'+data.mode + (data.inpaint === 1 ? "_inpaint" : "") +'/'+(data.proc_id)+ApiFetch.API_THUMB_EXT}
                                                alt={data.proc_id}
                                                data-no={i} data-type="generate" loading="lazy"
                                                id={"generated-"+data.proc_id}
                                            />
                                        </ImageListItem>
                                    ))}
                                    </ImageList>
                                </Container>
                                <Container className='text-center'>
                                    <Button className='m-3' onClick={() => {
                                        setDisplayAIGeneratedPanel(false)
                                        let images = []
                                        selectedGenerateImageList.forEach(d => {
                                            getAIGeneraleImageFile(d.proc_id).then(r => {
                                                if(r.result){
                                                    images = images.concat(r.data.img.map(img => {
                                                        return base64ToFile(img.replace(/^.*,/, ''),d.proc_id + ".png","image/png")
                                                    }))
                                                    return images
                                                } else {
                                                    return []
                                                }
                                            }).then(r => {
                                                if(selectedGenerateImageList.map(d => d.count).reduce((prev,current) => prev += current) === r.length){
                                                    imageAdd(images,true)
                                                    setSelectedGenerateImageList([])
                                                }
                                            })
                                        })
                                    }}>OK</Button>
                                    <Button className='m-3' onClick={() => {
                                        setDisplayAIGeneratedPanel(false)
                                        setSelectedGenerateImageList([])
                                    }}>Cancel</Button>
                                    <Button className='m-3' onClick={() => {
                                        setSelectedGenerateImageList([])
                                    }}>解除</Button>
                                </Container>
                            </Container>
                        }/>
                        ) : ""}
                    <Container id="crop-area">

                    </Container>
                    {showCropper ? (
                        <Container>
                    <Cropper
                        classes={{containerClassName: "cropper-container"}}
                        image={fileList.length > 0 && fileList[editImageNo].imageDataEdited}
                        crop={crop}
                        zoom={zoom}
                        aspect={cropTarget === "outside" ? 2 / 1 : 1 / 1}
                        onCropChange={setCrop}
                        onCropComplete={onCropComplete}
                        onZoomChange={setZoom}
                    />
                        <Container style={{position:"absolute",width:"300px",height:"110px",zIndex:3,left:window.innerWidth / 2 - 150,bottom:"120px",borderRadius:"10px",backgroundColor:"#EEEEEE"}} className="p-3">
                            <FloatingLabel controlId="crop-zoom" label="" className="mb-3"
                                style={{position:"absolute",zIndex:3,top:0,width:"90%",fontSize:"24px"}}
                            >
                                <Form.Range type="range" defaultValue={zoom} min={1} max={5} step={0.1} onChange={(e) => {
                                    setZoom(e.currentTarget.value)
                                }} />
                            </FloatingLabel>
                            <Button style={{position:"absolute",zIndex:3,left:"30px",bottom:"10px",fontSize:"24px"}} onClick={() => {
                                if(cropTarget === "inside"){
                                    setInsideThumbnail(tempThumbnail)
                                } else {
                                    setOutsideThumbnail(tempThumbnail)
                                }
                                setShowCropper(false)
                                
                            }}>OK</Button>
                            <Button variant='secondary' style={{position:"absolute",zIndex:3,right:"30px",bottom:"10px",fontSize:"24px"}} onClick={() => {
                                setShowCropper(false)
                            }}>Cancel</Button>
                            </Container>
                        </Container>
                    ) : ""}
                    <Container className='flex-wrap justify-content-center' style={{display:fileList.length > 0 ? "flex" : "none"}}>
                        <Container style={{border:"3px solid #000000",borderRadius:"5px",width:"250px",cursor:"pointer"}} className="p-2 text-center"
                            onClick={() => {
                                // スクロールを最上位に戻す
                                window.scrollTo({top:0,left:0,behavior:"instant"})
                                setShowCropper(true)
                                setCropTarget("inside")
                            }}
                        >

                            {t("common.thumbnail")} <Button variant='secondary'>{t("common.edit")}</Button><br />
                            <Container style={{width:"200px",height:"200px"}} className="p-0 mt-2">
                                {insideThumbnail === undefined ?
                                (<div style={{width:"200px",height:"200px",border:"1px solid #000000",paddingTop:"80px"}} >1:1</div>) : (
                                <Image id="crop-target-image" src={insideThumbnail} style={{objectFit:"cover",width:"100%",height:"100%",borderRadius:"10px"}} className="" />
                                )}
                            </Container>
                        </Container>
                        <Container style={{border:"3px solid #000000",borderRadius:"5px",width:"380px",height:"250px",cursor:"pointer"}} className="mt-3 p-2 text-center"
                            onClick={() => {
                                // スクロールを最上位に戻す
                                window.scrollTo({top:0,left:0,behavior:"instant"})
                                setShowCropper(true)
                                setCropTarget("outside")
                            }}
                        >

                            {t("common.thumbnailsForOutside")}(任意) <Button variant='secondary'>{t("common.edit")}</Button><br />
                            <Container style={{width:"360px",height:"180px"}} className="p-0 mt-2">
                                {outsideThumbnail === undefined ?
                                (<div style={{width:"360px",height:"180px",border:"1px solid #000000",paddingTop:"60px"}}>2:1</div>) : (
                                <Image id="crop-target-image-outside" src={outsideThumbnail} style={{objectFit:"cover",width:"100%",height:"100%",borderRadius:"10px"}} className="" />
                                )}
                            </Container>
                        </Container>
                    </Container>
                    {/* 読み込み用 */}
                    <Image id="load-image" className="d-none" />
                    {previewFlg ? (
                    <div style={{position:"fixed",top:0,left:0,width:"100%",height:"100%",zIndex:9999,cursor:"pointer"}} onClick={() => setPreviewFlg(false) }>
                        <div style={{position:"fixed",top:0,left:0,backgroundColor:"#000000",width:"100%",height:"100%",opacity:0.9}} />
                        <Image
                            src={previewSource}
                            id="preview"
                            style={{position:"fixed",objectFit:"contain",width:"100%",height:"100%"}}
                        />
                    </div>
                    ) : ""}
                    <Container style={{clear: "both"}} />
                    <Form style={{position:"relative"}}>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={8} xxl={12} style={{display:fileList.length > 0 ? "block" : "none",margin:"0 auto",width:"100%"}}>
                            <Container>
                                {t("upload.image.fileCount")}：<span style={{color:fileList.length > 300 ? "#FF0000" : "#000000",fontWeight:fileList.length > 300 ? "bold" : "normal"}}>{fileList.length}</span> / 300 File(s)
                                <ProgressBar id="file-select-progress" animated now={Math.floor((fileList.length / 300) * 100)} label={`${Math.floor((fileList.length / 300) * 100)}%`} style={{marginBottom:"10px"}} />
                                {t("upload.image.fileSize")}：<span style={{color:fileSizeOver ? "#FF0000" : "#000000",fontWeight:fileSizeOver ? "bold" : "normal"}}>{fileSize}</span> / 30 GB
                                <ProgressBar id="filesize-progress" animated now={Math.floor(fileSizeByte / maxFileSize * 100)} label={`${Math.floor(fileSizeByte / maxFileSize * 100)}%`} style={{marginBottom:"10px"}} />
                            </Container>
                            {/*<p>拡張子：jpg、png、gif、webp</p>*/}
                            {/* .jpg,.jpe,.jpeg,.jfif,.png,.gif,.webp,.bmp */}
                            <Form.Control type="file" encType="multipart/form-data" accept="*.*" className='d-none' id="file" multiple onChange={(e) => {
                                imageSet(e.currentTarget.files)
                                e.currentTarget.value = ""
                            }} />
                            <Form.Control type="file" encType="multipart/form-data" accept="*.*" className='d-none' id="file_add" multiple onChange={(e) => {
                                imageAdd(e.currentTarget.files)
                                e.currentTarget.value = ""
                            }} />
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto"}}>
                            <Button variant='outline-primary' id="aiGenCloseButton"
                                style={{marginRight:"10px",display:"none"}}
                                onClick={(e) => {
                                aiGenInitHandler()
                            }} disabled={false}>{t("upload.image.AIGeneration")}</Button>

                        </Col>
                    </Row>
                    <hr />
                    <Row className={param.generate === "generate" ? 'd-none' : ""}>
                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                            <h3>②{t("upload.image.info")}</h3>
                            <div style={{display:"block"}}>
                                <InputGroup className="mb-3" style={{maxWidth:"360px"}}>
                                    <InputGroup.Checkbox style={{cursor:"pointer"}} defaultChecked={promptInfoPublication} id="prompt-info-publication" onChange={(e) => {
                                        setPromptInfoPublication(e.currentTarget.checked)
                                    }} />
                                    <Form.Control type="text" value={t("upload.image.public")} readOnly />
                                </InputGroup>
                            </div>
                        </Col>
                        <Col xs={6} sm={5} md={6} lg={8} xl={8} xxl={9} style={{margin:"0 auto",display:"none"}}>
                            <InputGroup className="mb-3" style={{maxWidth:"360px"}}>
                                <InputGroup.Checkbox style={{cursor:"pointer"}} id="batch" onChange={(e) => {
                                        if(e.currentTarget.checked){
                                            setBatchMode(true)
                                            //setUseFilename(true)
                                        } else {
                                            setBatchMode(false)
                                            //document.getElementById("title").removeAttribute("disabled")
                                            //document.getElementById("title").value = ""
                                        }
                                    }} />
                                <Form.Control type="text" value={t("upload.image.batchPosting")} readOnly />
                                <Icon.QuestionCircle style={{marginLeft:"5px",cursor:"pointer"}} onClick={() => dialog("一括投稿とは",
                                <span >複数選択したファイルを1ファイル1投稿として連続で投稿できる機能です。<br />
                                一つ一つ投稿する手間を省きます。<br />
                                タイトルや概要などは入力したものがすべての投稿に設定されます。<br />
                                一括投稿を使用しない場合は、複数枚が1ページにまとめて投稿されます。</span>)} />
                            </InputGroup>
                        </Col>
                        <Col xs={6} sm={7} md={6} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                            {false && batchMode ? (
                            <InputGroup className="mb-3" style={{maxWidth:"360px"}}>
                                <InputGroup.Checkbox style={{cursor:"pointer",}} id="use_filename" onChange={(e) => {
                                        if(e.currentTarget.checked){
                                            setUseFilename(true)
                                            document.getElementById("title").setAttribute("disabled",e.currentTarget.checked)
                                            document.getElementById("title").value = "<ファイル名が設定されます>"
                                        } else {
                                            setUseFilename(false)
                                            document.getElementById("title").removeAttribute("disabled")
                                            document.getElementById("title").value = ""
                                        }
                                    }} />
                                <Form.Control type="text" style={{fontSize:"12px"}} defaultValue={"タイトルにファイル名を使用する"} readOnly />
                            </InputGroup>
                            ) : ""}
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto"}}>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <FloatingLabel controlId="title" label={<><span className='required'>必須</span> キャラクター名</>} className="mb-3 w-100">
                                    <Form.Control type="text" placeholder="" required autoComplete="new-password" 
                                        onChange={(e) => setCharacterName(e.currentTarget.value)}
                                    />
                                </FloatingLabel>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <FloatingLabel controlId="title" label={<>キャラクター名(ふりがな)</>} className="mb-3 w-100">
                                    <Form.Control type="text" placeholder="" required autoComplete="new-password" 
                                        onChange={(e) => setCharacterNameKana(e.currentTarget.value)}
                                    />
                                </FloatingLabel>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"10px auto"}} id="style-of-painting">
                                <p className='d-inline '><span className='required'>必須</span> キャラクターの性別 </p>
                                <ButtonGroup>
                                    {sexRadio.map((radio, idx) => (
                                        <ToggleButton
                                            className='p-1'
                                            key={idx}
                                            id={`sex-${idx}`}
                                            type="radio"
                                            variant={'outline-primary'}
                                            name="sex-radio"
                                            value={radio.value}
                                            checked={characterSex === radio.value}
                                            onChange={(e) => {
                                                setCharacterSex(e.currentTarget.value)
                                            }}
                                            >
                                            {radio.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"10px auto"}} id="style-of-painting">
                                <div style={{border:"1px solid #BBBBBB",borderRadius:"5px"}} className='p-2 d-inline-block mt-1'>
                                    キャラクターの誕生日を設定&nbsp;
                                        <ButtonGroup>
                                            {yesOrNoRadio.map((radio, idx) => (
                                                <ToggleButton
                                                    className='p-1'
                                                    key={idx}
                                                    id={`unit-sell-${idx}`}
                                                    type="radio"
                                                    variant={'outline-primary'}
                                                    name="unit-sell-radio"
                                                    value={radio.value}
                                                    checked={birthdaySet === radio.value}
                                                    onChange={(e) => {
                                                        setBirthdaySet(e.currentTarget.value)
                                                    }}
                                                    >
                                                    {radio.name}
                                                </ToggleButton>
                                            ))}
                                        </ButtonGroup>&nbsp;
                                        {birthdaySet === "1" ? (
                                            <>
                                                <FormControl sx={{ m: 1, minWidth: 120 }}>
                                                    <InputLabel id="month-label">月</InputLabel>
                                                    <Select
                                                        labelId="month-label"
                                                        id="month"
                                                        label="Month"
                                                        onChange={(e) => {setMonth(e.target.value)}}
                                                    >
                                                        <MenuItem value="">
                                                        <em>None</em>
                                                        </MenuItem>
                                                        {[months.map(d => {
                                                            return <MenuItem value={d}>{d}</MenuItem>
                                                        })]}
                                                    </Select>
                                                </FormControl>
                                                <FormControl sx={{ m: 1, minWidth: 120 }}>
                                                    <InputLabel id="day-label">日</InputLabel>
                                                    <Select
                                                        labelId="day-label"
                                                        id="day"
                                                        label="Day"
                                                        onChange={(e) => {setDay(e.target.value)}}
                                                    >
                                                        <MenuItem value="">
                                                        <em>None</em>
                                                        </MenuItem>
                                                        {[days.map(d => {
                                                            return <MenuItem value={d}>{d}</MenuItem>
                                                        })]}
                                                    </Select>
                                                </FormControl>
                                            </>
                                        ) : ""}
                                    </div>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <FloatingLabel controlId="title" label={<>キャラクターの年齢</>} className="mb-3 w-50">
                                    <Form.Control type="text" placeholder="" required autoComplete="new-password" 
                                        onChange={(e) => setCharacterAge(e.currentTarget.value)}
                                    />
                                </FloatingLabel>
                            </Col>
                            {showQuestionnairePopup ? (
                                <Questionnaire
                                    switch={setShowQuestionnairePopup}
                                    onSave={setQuestionInfo}
                                    options={questionInfo === undefined ? [] : questionInfo.options}
                                    deadlineDate={questionInfo === undefined ? "" : questionInfo.deadlineDate}
                                    deadlineTime={questionInfo === undefined ? "" : questionInfo.deadlineTime}
                                />
                            ) : ""}
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"10px auto"}} id="style-of-painting">
                                <p className='d-inline '><span className='required'>必須</span> {t("upload.image.styleOfPainting")} </p>
                                <ButtonGroup>
                                    {styles.map((radio, idx) => (
                                        <ToggleButton
                                            className='p-1'
                                            key={idx}
                                            id={`style-${idx}`}
                                            type="radio"
                                            variant={'outline-primary'}
                                            name="style-radio"
                                            value={radio.value}
                                            checked={styleOfPainting === radio.value}
                                            onChange={(e) => {
                                                setStyleOfPainting(e.currentTarget.value)
                                            }}
                                            >
                                            {radio.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto 10px auto"}} id="age-limit">
                                <p className='d-inline '><span className='required'>必須</span> {t("upload.image.ageLimit")} </p>
                                   <ButtonGroup>
                                    {nenrei.map((radio, idx) => (
                                        <ToggleButton
                                            className='p-1'
                                            key={idx}
                                            id={`age-limit-${idx}`}
                                            type="radio"
                                            variant={'outline-primary'}
                                            name="radio"
                                            value={radio.value}
                                            checked={ageLimit === radio.value}
                                            onChange={(e) => {
                                                if(e.currentTarget.value === "3" || e.currentTarget.value === "4" || e.currentTarget.value === "5"){
                                                    setSexualExpression("")
                                                }
                                                if(e.currentTarget.value === "1"){
                                                    setSexualExpression("")
                                                }
                                                if(e.currentTarget.value === "2"){
                                                    setSexualExpression("1")
                                                }
                                                setAgeLimit(e.currentTarget.value)
                                            }}
                                            >
                                            {radio.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>
                                {(ageLimit === "3" || ageLimit === "4" || ageLimit === "5") && 
                                <Container className='mt-3'>
                                    {t("upload.image.mosaic0")}<br /><br />
                                    <strong>{t("upload.image.mosaic1")}</strong><br />
                                    {t("upload.image.mosaic2")}<br />
                                    {t("upload.image.mosaic3")}<br />
                                    <Image src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/1.png"} width="300px" style={{border:"1px solid #CCCCCC"}} />
                                    <Image src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/2.png"} width="300px" style={{marginLeft:"10px",border:"1px solid #CCCCCC"}} />
                                </Container>}
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto 10px auto",display:ageLimit === "1" ? "block" : "none"}}>
                                <p className='d-inline'><span className='required'>必須</span> {t("upload.image.whatIsSexual")} </p>
                                <ButtonGroup>
                                    {yesOrNoRadio.map((radio, idx) => (
                                        <ToggleButton
                                            className='p-1'
                                            key={idx}
                                            id={`sexual-expression-${idx}`}
                                            type="radio"
                                            variant={'outline-primary'}
                                            name="sexual-radio"
                                            value={radio.value}
                                            checked={sexualExpression === radio.value}
                                            onChange={(e) => {
                                                if(e.currentTarget.value === "1"){
                                                    setAgeLimit("2")
                                                }
                                                setSexualExpression(e.currentTarget.value)
                                            }}
                                            >
                                            {radio.name}
                                        </ToggleButton>
                                    ))}
                                </ButtonGroup>
                                <Icon.QuestionCircle style={{marginLeft:"5px",cursor:"pointer"}} onClick={() => dialog("PG12とは ",
                                        <p>
                                            ■性的表現(軽微なものを含む) 
                                            性的なものを想起させる、接吻、抱擁・下着の露出など。
                                            性行為や類似する動作を連想させる表現や表情。
                                            胸や谷間、乳首、臀部、股間等の強調や際どい表現や構図。
                                            極端に面積の少ない衣類や水着を身に着けた人物の描画や、
                                            露出度の非常に高い人物の描写、透けた衣服を身に着けた人物の描写や全裸等。<br />
                                            ■その他刺激的な表現
                                            軽微な創傷や流血、薬物の登場、児童が真似をする可能性のあるもの
                                            流血表現または刺激的にはオプションのセンシティブフラグをつけてください。
                                        </p>)} />
                                <p className='mt-1'>流血または刺激的な表現にはオプションのセンシティブフラグをつけてください。</p>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <FloatingLabel controlId="description" label={"自己紹介"} className='mb-3 w-100'>
                                    <Form.Control
                                        as="textarea"
                                        style={{ height: '100px' }}
                                        required
                                        onChange={(e) => {
                                            setUseOdai(document.getElementById("description").value.indexOf("#"+odai) !== -1)
                                        }}
                                    />
                                </FloatingLabel>
                                {tagLatest.map((d,i) => <MuiButton key={i} variant='outlined' className='m-1 p-1' onClick={() => {
                                    document.querySelector("#description").value += " #" + d
                                }}>+{d}</MuiButton>)}
                                <br />
                                自己紹介を十分に入力すると、キャラクターとチャットできるようになります。
                                <Icon.QuestionCircle style={{marginLeft:"5px",cursor:"pointer"}} onClick={() => dialog("キャラクターとのチャット ",
                                        <p>
                                            チャットができるようになると、キャラクター画面の手紙アイコンからチャットできるようになります。<br />
                                            <img src="/img/character_chat.png" width={"100%"} />
                                        </p>)} />
                                <p>{t("upload.image.tag")}</p>
                                <Typeahead id="tag" placeholder={t("category.tag")} clearButton={true} multiple
                                className='mb-1'
                                onInputChange={(input) => {
                                    tagSearch(input).then(r => {
                                        if(r.result){
                                            setTagOptions(r.data)
                                        }
                                    })
                                }}
                                onChange={(selected) => {
                                    setTag(selected)
                                }}
                                options={tagOptions}
                                />
                            </Col>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                            <FloatingLabel controlId="title" label={<>趣味</>} className="mb-3 w-100">
                                <Form.Control type="text" placeholder="" required autoComplete="new-password" 
                                    onChange={(e) => setHobby(e.currentTarget.value)}
                                />
                            </FloatingLabel>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                            <FloatingLabel controlId="notes" label={"二次創作ガイドラインやプロンプト利用の際の注意事項"} className='mb-3 w-100'>
                            <Form.Control
                                as="textarea"
                                style={{ height: '100px' }}
                                required
                                onChange={(e) => {
                                    setNotes(e.currentTarget.value)
                                }}
                            />
                            </FloatingLabel>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"10px auto"}} id="style-of-painting">
                            <p className='d-inline '><span className='required'>必須</span> ファンアートを許可 </p>
                            <ButtonGroup>
                                {yesOrNoRadio.reverse().map((radio, idx) => (
                                    <ToggleButton
                                        className='p-1'
                                        key={idx}
                                        id={`fanart-${idx}`}
                                        type="radio"
                                        variant={'outline-primary'}
                                        name="fanart-radio"
                                        value={radio.value}
                                        checked={fanart === radio.value}
                                        onChange={(e) => {
                                            setFanart(e.currentTarget.value)
                                        }}
                                        >
                                        {radio.name}
                                    </ToggleButton>
                                ))}
                            </ButtonGroup>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                            <InputGroup className='mb-3'>
                                <InputGroup.Text>{fanart === "1" ? <><span className='required'>必須</span>&nbsp;</> : ""}#</InputGroup.Text>
                                <Form.Control type="text" placeholder="ファンアート専用ハッシュタグ" required autoComplete="new-password" 
                                    id='fanart-hash-tag'
                                    onChange={(e) => setFanartHashTag(e.currentTarget.value)}
                                />
                            </InputGroup>
                            <InputGroup className='mb-3'>
                                <InputGroup.Text>@</InputGroup.Text>
                                <Form.Control type="text" placeholder="X ID" required autoComplete="new-password" 
                                    id='x-id'
                                    onChange={(e) => setXId(e.currentTarget.value)}
                                />
                            </InputGroup>
                            <InputGroup className='mb-3'>
                                <InputGroup.Text>@</InputGroup.Text>
                                <Form.Control type="text" placeholder="YouTube ID" required autoComplete="new-password" 
                                    id='yotuube-id'
                                    onChange={(e) => setYouTubeId(e.currentTarget.value)}
                                />
                            </InputGroup>
                            <InputGroup className='mb-3'>
                                <InputGroup.Text>@</InputGroup.Text>
                                <Form.Control type="text" placeholder="Instagram ID" required autoComplete="new-password" 
                                    id='instagram-id'
                                    onChange={(e) => setInstagramId(e.currentTarget.value)}
                                />
                            </InputGroup>
                            <InputGroup className='mb-3'>
                                <InputGroup.Text>@</InputGroup.Text>
                                <Form.Control type="text" placeholder="TikTok ID" required autoComplete="new-password" 
                                    id='tiktok-id'
                                    onChange={(e) => setTiktokId(e.currentTarget.value)}
                                />
                            </InputGroup>
                            <InputGroup className='mb-3'>
                                <InputGroup.Text>sns.ourt-ai.work/@</InputGroup.Text>
                                <Form.Control type="text" placeholder="Misskey ID(ourt AI)" required autoComplete="new-password" 
                                    id='misskey-id'
                                    onChange={(e) => setMisskeyId(e.currentTarget.value)}
                                />
                            </InputGroup>
                            <InputGroup className='mb-3'>
                                <InputGroup.Text>@</InputGroup.Text>
                                <Form.Control type="text" placeholder="Discord User Name" required autoComplete="new-password" 
                                    id='discord-user-name'
                                    onChange={(e) => setDiscordUserName(e.currentTarget.value)}
                                />
                            </InputGroup>
                            <InputGroup className='mb-3'>
                                <InputGroup.Text>@</InputGroup.Text>
                                <Form.Control type="text" placeholder="GitHub ID" required autoComplete="new-password" 
                                    id='github-id'
                                    onChange={(e) => setGitHubId(e.currentTarget.value)}
                                />
                            </InputGroup>
                            <InputGroup className='mb-3'>
                                <InputGroup.Text>@</InputGroup.Text>
                                <Form.Control type="text" placeholder="Hugging Face ID" required autoComplete="new-password" 
                                    id='huggingface-id'
                                    onChange={(e) => setHuggingFaceId(e.currentTarget.value)}
                                />
                            </InputGroup>
                            <InputGroup className='mb-3'>
                                <InputGroup.Text><Icon.House /></InputGroup.Text>
                                <Form.Control type="text" placeholder="ホームページ" required autoComplete="new-password" 
                                    id='homepage'
                                    onChange={(e) => setHomepage(e.currentTarget.value)}
                                />
                            </InputGroup>
                        </Col>
                        <hr />
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto"}}>
                            <Col xs={6} sm={6} md={6} lg={4} xl={3} xxl={3} style={{margin:"40px auto",display:"none"}}>
                                <p>{t("upload.image.promptMulti")}</p>
                                <MuiButton className='mb-3' variant='outlined' color='error' onClick={() => deleteSelectedFormValue()}>
                                    {t("upload.image.deleteCurrentInfo")}
                                </MuiButton>
                                <p style={{display:"block"}}>{t("upload.image.useModelRequired")}</p>
                                <Typeahead id="ai-model-input" ref={ref} placeholder={"Search"} clearButton={true}
                                onInputChange={(input) => {
                                    let value = input === undefined ? "no-select" : input
                                    if(fileList.length > 0){
                                        fileList[editImageNo].software = value
                                    }
                                    document.getElementById("ai-model").value = value
                                }}
                                onChange={(selected) => {
                                    let value = selected.length === 0 ? "no-select" : selected[0]
                                    if(fileList.length > 0){
                                        fileList[editImageNo].software = value
                                    }
                                    document.getElementById("ai-model").value = value
                                }}
                                //disabled={fileList.length > 0 && fileList[editImageNo].useAIGeneration}
                                options={[
                                    "StableDiffusion",
                                    "StableDiffusion_v1-1",
                                    "StableDiffusion_v1-2",
                                    "StableDiffusion_v1-3",
                                    "StableDiffusion_v1-4",
                                    "StableDiffusion_v1-5",
                                    "StableDiffusion_v2-1",
                                    "StableDiffusionXL",
                                    "StableDiffusion3",
                                    "StableDiffusion3Turbo",
                                    "NovelAI",
                                    "HolaraAI",
                                    "Agelesnate",
                                    "AgelesnateV1_1",
                                    "AgelesnateV1_2",
                                    "AgelesnateV1_21",
                                    "AgelesnateV2",
                                    "AgelesnateV3",
                                    "animelike25D",
                                    "Aurora_v1.0",
                                    "Animagine_XL_V3",
                                    "Animagine_XL_V3.1",
                                    "AnythingV3",
                                    "AnythingV4",
                                    "AnythingV4.5",
                                    "AnythingV5",
                                    "AbyssOrangeMix",
                                    "AbyssOrangeMix2",
                                    "AbyssOrangeMix3",
                                    "ACertainThing",
                                    "ACertainModel",
                                    "ACertainty",
                                    "AikimiD1",
                                    "AikimiXW1",
                                    "AikimiXR1",
                                    "AikimiXR2",
                                    "AikimiXR3",
                                    "AikimiXR4",
                                    "AikimiXR5",
                                    "Aikimi_dB4",
                                    "Aikimi_dC3",
                                    "Aikimi_dC4",
                                    "AikiliMX2",
                                    "AikiMIXSD2v1",
                                    "blue_pencil-v1",
                                    "blue_pencil-v1b",
                                    "blue_pencil-v2",
                                    "blue_pencil-v2b",
                                    "blue_pencil-v3",
                                    "blue_pencil-v4",
                                    "blue_pencil-v5",
                                    "blue_pencil-v5b",
                                    "blue_pencil-v6",
                                    "blue_pencil-v7",
                                    "blue_pencil-v8",
                                    "blue_pencil-v9",
                                    "blue_pencil-v9b",
                                    "blue_pencil-v10",
                                    "blue_pencil-EX",
                                    "blue_pencil_realistic-v0.1",
                                    "blazingDrive_V09i",
                                    "EverlastingV2",
                                    "7th_anime_v3_testA",
                                    "7th_anime_v3_testB",
                                    "7th_anime_v3_testC",
                                    "7th_anime_3.1_A",
                                    "7th_anime_3.1_B",
                                    "7th_anime_3.1_C",
                                    "7th_anime_3.1_Cg",
                                    "7th_anime_v2.1_B",
                                    "Baka-DiffusionV1",
                                    "CounterfeitV1.0",
                                    "CounterfeitV2.0",
                                    "CounterfeitV2.2",
                                    "CounterfeitV2.5",
                                    "CounterfeitV3.0",
                                    "CinnamonMix",
                                    "ChilloutMix",
                                    "chilled_remix_v1Fp16vae",
                                    "chilled_remix_v1vae",
                                    "chilled_remixb_v1vae",
                                    "chilled_reversemix_v1vae",
                                    "DALL-E2",
                                    "DALL-E3",
                                    "Defmix",
                                    "demiPeroMixV1",
                                    "demiPeroMixV2",
                                    "DivineEleganceMixV1",
                                    "DivineEleganceMixV2",
                                    "DivineEleganceMixV3",
                                    "Elysium_V1",
                                    "Elysium_Anime_V1",
                                    "Elysium_Anime_V2",
                                    "Elysium_Anime_V3",
                                    "Elysium_Kuro_Anime_V1",
                                    "HentaiDiffusion",
                                    "Hassaku_V1to1.2-inpainting",
                                    "Hassaku_V1",
                                    "Hassaku_V1m",
                                    "Hassaku_V1.1",
                                    "Hassaku_V1.2",
                                    "OsukiniMix_A",
                                    "OsukiniMix_B",
                                    "OsukiniMix_B_V2",
                                    "SEmix_V1_A",
                                    "SEmix_V1_B",
                                    "SEmix_V1_C",
                                    "SEmix_V2_A",
                                    "SEmix_V2_B",
                                    "Shining_Mix_V1",
                                    "Shining_Mix_V2",
                                    "Shirayuki_General_V1",
                                    "Shirayuki_Anime_V1",
                                    "SukumizuMix",
                                    "WaifuDiffusion",
                                    "SukiyakiMix",
                                    "SukiAnimix",
                                    "majicmixRealistic_v6",
                                    "Midjourney",
                                    "Midjourney_V5",
                                    "Microsoft Bing Image Creator",
                                    "milktea_mild_V1",
                                    "niji・journey",
                                    "niji・journey_V5",
                                    "TrinArt",
                                    "Ernie-vilg",
                                    "UnstableDiffusion",
                                    "MeituAIPainting",
                                    "Rabbit_v1.3",
                                    "Rivera",
                                    "PastelMix",
                                    "PerfectSketchbook",
                                    "Protogen",
                                    "お絵描きばりぐっどくん",
                                    "えいあーとAI",
                                    /*"ourt AI Diffusion (Anime V1)",*/
                                    "ourt AI Diffusion (Anime V2)",
                                    "ourt AI Diffusion (Anime V3)",
                                    "ourt AI Diffusion (Anime V3.5)",
                                    "未使用",
                                    "マージモデル(名称なし)",
                                    "オリジナルモデル"
                                    ]}
                                />
                                <FloatingLabel controlId="ai-model" label={t("upload.image.useModel")} className="mb-3" style={{display:"block"}}>
                                    <Form.Control type="text" placeholder=""
                                        //disabled={fileList.length > 0 && fileList[editImageNo].useAIGeneration}
                                        onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].software = e.currentTarget.value
                                    }} />
                                </FloatingLabel>
                                <MuiButton className='mb-0' variant='outlined' onClick={() => {
                                    let model = document.getElementById("ai-model").value
                                    if(model === "" || model === "no-select"){
                                        dialog("確認",t("upload.image.useModelRequired"))
                                        return
                                    }
                                    fileList.forEach(d => {
                                        d.software = model
                                    })
                                    dialog("確認",t("upload.image.useModelLeft")+"「"+model+"」"+t("upload.image.useModelRight"))
                                }}>
                                    {t("upload.image.allUseSameModel")}
                                </MuiButton>
                            </Col>
                            <Col xs={6} sm={6} md={6} lg={4} xl={3} xxl={3} style={{margin:"30px auto",display:"none"}}>
                                <FloatingLabel controlId="model-version" label={t("upload.image.modelVersion")} className="mb-3" style={{display:"block"}}>
                                    <Form.Control type="text" placeholder="" readOnly disabled />
                                </FloatingLabel>
                            </Col>
                            {fileList.length > 0 && fileList[editImageNo] ? (
                                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="m-1">
                                    <Container style={{width:"240px",height:"auto",display:"block"}}>
                                        <Container className='text-center'>
                                            {t("upload.image.edittingInfo")}
                                        </Container>
                                        <Container className='d-flex justify-content-between mb-3'>
                                            <MuiButton variant='outlined' onClick={() => {
                                                if(editImageNo > 0){
                                                    setEditImageNo(editImageNo - 1)
                                                }
                                                }} disabled={editImageNo === 0}>
                                                <Icon.ArrowLeft /></MuiButton>
                                            <MuiButton variant='outlined' onClick={() => {
                                                if(editImageNo < fileList.length){
                                                    setEditImageNo(editImageNo + 1)
                                                }
                                                }} disabled={editImageNo === fileList.length - 1} >
                                                <Icon.ArrowRight /></MuiButton>
                                        </Container>
                                        <Container>
                                            <Image alt={fileList[editImageNo].file.name} src={fileList[editImageNo].imageDataMiddle} id="select-img" style={{objectFit:"contain",width:"100%",height:"100%",cursor:"pointer"}}
                                            onClick={(e) => {
                                                setPreviewSource(fileList[editImageNo].useMosaic === "1" ? fileList[editImageNo].imageDataEdited : fileList[editImageNo].imageDataOriginal)
                                                setPreviewFlg(true)
                                            }}/>
                                        </Container>
                                    </Container>
                                </Col>
                            ) : ""}
                            <Col xs={6} sm={6} md={6} lg={4} xl={3} xxl={3} style={{margin:"10px auto",display:promptInfoPublication ? "block" : "none"}}>
                                <Form.Control type="file" encType="multipart/form-data" accept="*.*" className='d-none' id="read-prompt-info-file" onChange={(e) => {
                                    let img = new ImageFile({file:e.currentTarget.files[0]})
                                    setMetaData(e.currentTarget.files[0],img).then(r => {
                                        setMetaDataField(img,true)
                                        if(editImageNo !== -1){
                                            fileList[editImageNo].prompt = img.prompt
                                            fileList[editImageNo].software = img.software
                                            fileList[editImageNo].modelHash = img.modelHash
                                            fileList[editImageNo].comment = img.comment
                                        }
                                    })
                                    e.currentTarget.value = ""
                                }} />
                                <MuiButton variant='outlined' onClick={() => document.getElementById("read-prompt-info-file").click()}>プロンプト情報だけ読み込む</MuiButton>
                            </Col>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto",display:promptInfoPublication ? "block" : "none"}}>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <FloatingLabel controlId="prompt" label={t("upload.image.promptName")} className='mb-3 w-100' style={{display:"block"}}>
                                    <Form.Control
                                        as="textarea"
                                        style={{ height: '100px' }}
                                        required
                                        onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].prompt = e.currentTarget.value
                                        }}
                                    />
                                </FloatingLabel>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                                <FloatingLabel controlId="negative-prompt" label={t("upload.image.negativePromptName")} className='mb-3 w-100' style={{display:"block"}}>
                                    <Form.Control
                                        as="textarea"
                                        style={{ height: '100px' }}
                                        required
                                        onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.uc = e.currentTarget.value
                                        }}
                                    />
                                </FloatingLabel>
                            </Col>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto",display:"none"}}>
                            <Row>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="noise" label="Noise" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.noise = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="steps" label="Steps" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.steps = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="scale" label="Scale" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.scale = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="seed" label="Seed" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.seed = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="sampler" label="Sampler" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.sampler = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="strength" label="Denoising strength" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.strength = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="mask-blur" label="Mask blur" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.maskBlur = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="clip-skip" label="Clip skip" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.clipSkip = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="ensd" label="ENSD" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.ensd = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="hires-upscale" label="Hires Upscale" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.maskBlur = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="hires-upscaler" label="Hires Upscaler" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.hiresUpscaler = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="controlnet-enabled" label="ControlNet Enabled" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.controlNetEnabled = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="controlnet-module" label="ControlNet Module" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.controlNetModule = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="controlnet-model" label="ControlNet Model" className="mb-3" style={{display:"block"}}>
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.controlNetModel = e.currentTarget.value
                                        }} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="controlnet-weight" label="ControlNet Weight" className="mb-3" style={{display:"block"}} autoComplete="new-password">
                                        <Form.Control type="text" placeholder="" required onChange={(e) => {
                                            if(fileList.length > 0)
                                            fileList[editImageNo].comment.controlNetWeight = e.currentTarget.value
                                        }} autoComplete="new-password" />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto"}}>
                                    <FloatingLabel controlId="raw-info" label={"rawinfo"} className='mb-3 w-100' style={{display:"block"}}>
                                        <Form.Control
                                            as="textarea"
                                            style={{ height: '100px' }}
                                            required
                                            onChange={(e) => {
                                                if(fileList.length > 0)
                                                fileList[editImageNo].rawInfo = e.currentTarget.value
                                            }}
                                        />
                                    </FloatingLabel>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto",display:"none"}}>
                            <Accordion flush style={{border:"1px solid #CCCCCC"}} className="mb-3">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header><RIcon.FaDesktop style={{fontSize:"18px"}} />&nbsp;{t("common.others")}</Accordion.Header>
                                        <Accordion.Body>
                                            <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto",width:"100%"}}>
                                                <Typeahead id="vae" placeholder={"VAE"} clearButton={true}
                                                onInputChange={(input) => {
                                                    let value = input === undefined ? "" : input
                                                    if(fileList.length > 0){
                                                        fileList[editImageNo].vae = value
                                                        setVAE([value])
                                                    }
                                                }}
                                                onChange={(selected) => {
                                                    let value = selected.length === 0 ? "" : selected[0]
                                                    if(fileList.length > 0){
                                                        fileList[editImageNo].vae = value
                                                        setVAE([value])
                                                    }
                                                }}
                                                options={[
                                                    "Anything-V3.0.vae",
                                                    "anything-v4.0.vae",
                                                    "autoencoder_fix_kl-f8-trinart_characters",
                                                    "ACertainModel.vae",
                                                    "Baka-Diffusion.vae",
                                                    "clearvae_main.safetensors",
                                                    "vae-ft-ema-560000-ema-pruned",
                                                    "vae-ft-mse-840000-ema-pruned",
                                                    "kl-f8-anime",
                                                    "kl-f8-anime2",
                                                    "mse840000_klf8anime.vae",
                                                    "mse840000_klf8anime_klf8anime2.vae",
                                                    ]}
                                                selected={vae}
                                                />
                                            </Col>
                                            <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto",width:"100%"}}>
                                                <Typeahead id="gpu" placeholder={"GPU"} clearButton={true}
                                                onInputChange={(input) => {
                                                    let value = input === undefined ? "" : input
                                                    if(fileList.length > 0){
                                                        fileList[editImageNo].gpu = value
                                                        setGPU([value])
                                                    }
                                                }}
                                                onChange={(selected) => {
                                                    let value = selected.length === 0 ? "" : selected[0]
                                                    if(fileList.length > 0){
                                                        fileList[editImageNo].gpu = value
                                                        setGPU([value])
                                                        console.log(selected)
                                                    }
                                                }}
                                                options={[
                                                    "GeForce GTX 950","GeForce GTX 960","GeForce GTX 970","GeForce GTX 980","GeForce GTX 980 Ti",
                                                    "GeForce GTX 950M (Notebooks)","GeForce GTX 960M (Notebooks)","GeForce GTX 965M (Notebooks)","GeForce GTX 970M (Notebooks)","GeForce GTX 980M (Notebooks)","GeForce GTX 980 (Notebooks)",
                                                    "GeForce GTX 1050","GeForce GTX 1050 Ti","GeForce GTX 1060","GeForce GTX 1070","GeForce GTX 1070 Ti","GeForce GTX 1080","GeForce GTX 1080 Ti",
                                                    "GeForce GTX 1050 (Notebooks)","GeForce GTX 1050 Ti (Notebooks)","GeForce GTX 1060 (Notebooks)","GeForce GTX 1070 (Notebooks)","GeForce GTX 1080 (Notebooks)",
                                                    "Geforce GTX 1630","Geforce GTX 1650","Geforce GTX 1650 SUPER","Geforce GTX 1660","Geforce GTX 1660 Ti","Geforce GTX 1660 SUPER",
                                                    "Geforce GTX 1650 (Notebooks)","Geforce GTX 1650 Ti (Notebooks)","Geforce GTX 1660 Ti (Notebooks)",
                                                    "GeForce RTX 2050 (Notebooks)","GeForce RTX 2060 (Notebooks)","GeForce RTX 2070 (Notebooks)","GeForce RTX 2070 SUPER (Notebooks)","GeForce RTX 2080 (Notebooks)","GeForce RTX 2080 SUPER (Notebooks)",
                                                    "GeForce RTX 2060","GeForce RTX 2060 SUPER","GeForce RTX 2070","GeForce RTX 2070 SUPER","GeForce RTX 2080","GeForce RTX 2080 SUPER","GeForce RTX 2080 Ti",
                                                    "GeForce RTX 3050","GeForce RTX 3060","GeForce RTX 3060 Ti","GeForce RTX 3070","GeForce RTX 3070 Ti","GeForce RTX 3080","GeForce RTX 3080 Ti","GeForce RTX 3090","GeForce RTX 3090 Ti",
                                                    "GeForce RTX 3050 Laptop GPU","GeForce RTX 3050 Ti Laptop GPU","GeForce RTX 3060 Laptop GPU","GeForce RTX 3070 Laptop GPU","GeForce RTX 3070 Ti Laptop GPU","GeForce RTX 3080 Laptop GPU","GeForce RTX 3080 Ti Laptop GPU",
                                                    "GeForce RTX 4070 Ti","GeForce RTX 4080","GeForce RTX 4090",
                                                    "GeForce RTX 4050 Laptop GPU","GeForce RTX 4060 Laptop GPU","GeForce RTX 4070 Laptop GPU","GeForce RTX 4080 Laptop GPU","GeForce RTX 4090 Laptop GPU",
                                                    "NVIDIA A100"
                                                    ]}
                                                selected={gpu}
                                                />
                                            </Col>
                                            <Col xs={4} sm={4} md={6} lg={4} xl={4} xxl={4} style={{margin:"0 auto",width:"100%"}}>
                                                <Typeahead id="vram" placeholder={"VRAM"} clearButton={true}
                                                onInputChange={(input) => {
                                                    let value = input === undefined ? "" : input
                                                    if(fileList.length > 0){
                                                        fileList[editImageNo].vram = value
                                                        setVRAM([value])
                                                    }
                                                }}
                                                onChange={(selected) => {
                                                    let value = selected.length === 0 ? "" : selected[0]
                                                    if(fileList.length > 0){
                                                        fileList[editImageNo].vram = value
                                                        setVRAM([value])
                                                    }
                                                }}
                                                options={["1GB","2GB","4GB","6GB","8GB","12GB","16GB","24GB","32GB","36GB","48GB"]}
                                                selected={vram}
                                                />
                                            </Col>
                                        </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={9} style={{margin:"0 auto"}}>
                            <hr />
                            <FloatingLabel controlId="request" label={t("upload.image.requestMessage")} className='mb-3 w-100' style={{display:"block"}}>
                                <Form.Control
                                    as="textarea"
                                    style={{ height: '100px' }}
                                    required
                                />
                            </FloatingLabel>
                            <div id="upload-form">
                                {bookingDate !== "" && bookingTime !== "" ?(
                                    <Container className='mt-1'>
                                        {t("common.yoyaku")}:{bookingDate !== "" ? bookingDate : ""} {bookingTime !== "" ? bookingTime : ""}
                                    </Container>
                                ): ""}
                                <MuiButton variant='contained' color={uploadReady ? "primary" : "warning"} style={{marginTop:"10px",marginBottom:"10px",width:"200px"}} onClick={(e) => uploadHandler(e)} disabled={uploading}>{t("upload.image.upload")}</MuiButton>
                                <Button variant={uploadReady ? "primary" : "danger"} style={{position:"fixed",zIndex:2,left:window ? (window.innerWidth - 200) / 2 : 0,bottom:"60px",width:"200px"}} onClick={(e) => uploadHandler(e)} disabled={uploading}>
                                    {t("upload.image.upload")}
                                    {uploading && (<><br /><ProgressBar className="progress" animated now={progressNow} label={`${progressLabel}`} /></>)}
                                </Button>
                            </div>
                            <p>
                                <Link to='/terms'>利用規約</Link>に違反する投稿は削除の対象となります。
                            </p>
                            {loginInfo.plan === "basic" || loginInfo.plan === "certification" || loginInfo.plan === "unlimited" || loginInfo.plan === "plus" ? "" : (
                                <iframe src="https://rcm-fe.amazon-adsystem.com/e/cm?o=9&p=294&l=ur1&category=kindleunlimited&banner=1D102G5E4DY0DNM0T382&f=ifr&linkID=1f2ebcba4ab1b661743a03341e6b1aa2&t=ourt-ai-22&tracking_id=ourt-ai-22" width="320" height="100" scrolling="no" border="0" marginWidth="0" style={{border:"none"}} frameBorder="0" sandbox="allow-scripts allow-same-origin allow-popups allow-top-navigation-by-user-activation"></iframe>
                            )}
                            {uploading && (<><ProgressBar className="progress" animated now={progressNow} label={`${progressLabel}`} style={{marginBottom:"10px"}} /></>)}
                            {uploading && batchUploading && (<><ProgressBar id="batch_progress" animated now={batchProgressNow} label={`${batchProgressLabel}`} style={{marginBottom:"10px"}} /></>)}
                        </Col>
                    </Row>
                    </Form>
        </Container>
        {postedGroupId === "" ? (<Footer />) : ""}
    </div>
    </>
    )
}

export default UploadCharacter;
